package com.raouf.mehrguard.web.i18n

internal val GermanStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "Kotlin Multiplatform QRishing-Detektor",
    WebStringKey.MenuMain to "Hauptmenü",
    WebStringKey.MenuSecurity to "Sicherheit",
    WebStringKey.MenuSystem to "Systemmenü",
    WebStringKey.NavDashboard to "Übersicht",
    WebStringKey.NavScanMonitor to "Scanmonitor",
    WebStringKey.NavScanHistory to "Scanverlauf",
    WebStringKey.NavTrustCentre to "Vertrauenszentrum",
    WebStringKey.NavReports to "Berichte",
    WebStringKey.NavTraining to "Schulung",
    WebStringKey.NavSettings to "Einstellungen",
    WebStringKey.QuickActions to "Schnellaktionen",

    // Hero Section
    WebStringKey.HeroTagline to "Sicher. Offline.",
    WebStringKey.HeroTagline2 to "Erklärbare Verteidigung.",
    WebStringKey.HeroDescription to "Mehr Guard analysiert potenzielle Bedrohungen direkt auf Ihrer Hardware. Erleben Sie Schutz ohne Latenz.",
    
    // Dashboard
    WebStringKey.StartScan to "Neuen Scan starten",
    WebStringKey.ImportImage to "Bild importieren",
    WebStringKey.ScanQrCode to "QR-Code scannen",
    WebStringKey.SystemHealth to "Systemzustand",
    WebStringKey.ThreatDatabase to "Bedrohungsdatenbank",
    WebStringKey.Current to "Aktuell",
    WebStringKey.Active to "Aktiv",
    WebStringKey.Threats to "Bedrohungen",
    WebStringKey.SafeScans to "Sichere Scans",
    WebStringKey.EngineActive to "Engine aktiv",
    WebStringKey.EnterpriseProtection to "Enterprise-Schutz aktiv",
    WebStringKey.SystemOptimal to "System optimal",
    WebStringKey.EngineStatus to "Engine v2.4 • Vor 2h aktualisiert",
    WebStringKey.ThreatsBlocked to "Blockierte Bedrohungen",
    WebStringKey.AllSystemsOperational to "Alle Systeme betriebsbereit",

    // Dashboard Sections
    WebStringKey.SectionOverview to "Übersicht",
    WebStringKey.SectionSecurity to "Sicherheit",
    WebStringKey.SectionTraining to "Schulung",
    WebStringKey.SectionReports to "Berichte",
    WebStringKey.OfflineReady to "Offline bereit",
    WebStringKey.OfflineDescription to "Lokale Datenbank v2.4.1 aktiv. Keine Daten verlassen dieses Gerät.",
    
    // Trust Centre
    WebStringKey.TrustCentreTitle to "Vertrauenszentrum",
    WebStringKey.OfflineGuarantee to "Strenge Offline-Garantie",
    WebStringKey.OfflineGuaranteeDesc to "Die Mehr Guard-Analyse läuft vollständig auf der Neural Engine Ihres Geräts. URL-Daten verlassen niemals Ihr Telefon.",
    WebStringKey.ThreatSensitivity to "Bedrohungsempfindlichkeit",
    WebStringKey.ResetConfirm to "Dies setzt alle Trust Centre-Einstellungen auf die Standardwerte zurück.",
    
    // Settings Quick Actions
    WebStringKey.ThreatMonitor to "Bedrohungsmonitor",
    WebStringKey.ThreatMonitorDesc to "Live-Bedrohungen anzeigen und Sicherheitsaudit ausführen",
    WebStringKey.TrustCentreDesc to "Datenschutzeinstellungen und Bedrohungsempfindlichkeit",
    WebStringKey.ExportReport to "Bericht exportieren",
    WebStringKey.ExportReportDesc to "PDF- oder JSON-Sicherheitsbericht erstellen",

    // Dashboard Content
    WebStringKey.Analyze to "Analysieren",
    WebStringKey.HeuristicEngine to "Heuristik-Engine",
    WebStringKey.HighPerformanceEngine to "Hochleistungs-Engine",
    WebStringKey.RecentScans to "Letzte Scans",
    WebStringKey.ViewFullHistory to "Vollständigen Verlauf anzeigen",
    WebStringKey.Status to "Zustand",
    WebStringKey.Source to "Quelle",
    WebStringKey.Details to "Details",
    WebStringKey.Time to "Zeit",
    WebStringKey.Version to "Ausführung",
    WebStringKey.LastUpdate to "Letztes Update",
    WebStringKey.Signatures to "Signaturen",
    WebStringKey.CheckForUpdates to "Nach Updates suchen",
    WebStringKey.FeatureOfflineTitle to "Offline-First Architektur",
    WebStringKey.FeatureOfflineDesc to "Die gesamte Analyse erfolgt lokal. Ihr Kamera-Feed und Ihre gescannten Daten berühren niemals einen externen Server, was absolute Privatsphäre gewährleistet.",
    WebStringKey.FeatureExplainableTitle to "Erklärbare Sicherheit",
    WebStringKey.FeatureExplainableDesc to "Erhalten Sie nicht nur ein \"Block\". Wir bieten detaillierte heuristische Aufschlüsselungen von URL-Parametern, Weiterleitungen und Javascript-Payloads.",
    WebStringKey.FeaturePerformanceDesc to "Optimiert für Desktop-Umgebungen. Scans werden in unter 5ms mit nativen Kotlin Multiplatform-Binärdateien verarbeitet.",
    WebStringKey.TrainingCentre to "Trainingszentrum",
    WebStringKey.LearnHomograph to "Lernen Sie, fortgeschrittene QR-Homograph-Angriffe zu identifizieren.",
    WebStringKey.BeatTheBotAction to "Beat the Bot →",
    WebStringKey.NoScansYet to "Noch keine Scans. Starten Sie einen neuen Scan, um hier Ergebnisse zu sehen.",
    WebStringKey.VerdictSafe to "SICHER",
    WebStringKey.VerdictPhish to "PHISHING",
    WebStringKey.VerdictWarn to "WARNUNG",
    WebStringKey.ScoreLabel to "Punktzahl:",

    // Scanner
    WebStringKey.ActiveScanner to "Aktiver Scanner",
    WebStringKey.OfflineMode to "Offline-Modus",
    WebStringKey.LiveFeedDisconnected to "LIVE-FEED GETRENNT",
    WebStringKey.CameraAccessRequired to "Kamerazugriff erforderlich",
    WebStringKey.CameraAccessDescription to "Ziehen Sie ein QR-Code-Bild hierher oder aktivieren Sie den Kamerazugriff, um mit dem Scannen zu beginnen.",
    WebStringKey.EnableCamera to "Kamera aktivieren",
    WebStringKey.Scanning to "Scanne...",
    WebStringKey.ScanHint to "Stillhalten. Offline analysiert in <5ms.",
    WebStringKey.Torch to "Taschenlampe",
    WebStringKey.Gallery to "Galerie",
    WebStringKey.PasteUrl to "URL einfügen",
    WebStringKey.PasteUrlTitle to "URL zum Analysieren einfügen",
    WebStringKey.AnalyzeUrl to "URL analysieren",
    WebStringKey.SystemStatus to "Systemstatus",
    WebStringKey.PhishingEngine to "Phishing-Engine",
    WebStringKey.Ready to "BEREIT",
    WebStringKey.LocalDb to "Lokale DB",
    WebStringKey.Latency to "Latenz",
    WebStringKey.ViewAll to "Alle anzeigen",

    // Threat / Results
    WebStringKey.BreadcrumbHome to "Startseite",
    WebStringKey.BreadcrumbScans to "Scans durchgeführt",
    WebStringKey.OfflineProtection to "Offline-Schutz",
    WebStringKey.VerdictHighRisk to "HOHES RISIKO ERKANNT",
    WebStringKey.VerdictDangerous to "Gefährlich",
    WebStringKey.VerdictDangerousDesc to "Der gescannte QR-Code enthält bösartige Indikatoren im Zusammenhang mit Phishing und Anmeldeinformationen-Diebstahl. Fahren Sie nicht mit der Ziel-URL fort.",
    WebStringKey.ThreatConfidence to "Bedrohungssicherheit",
    WebStringKey.FlagPhishing to "Phishing-Versuch",
    WebStringKey.FlagObfuscated to "Verschleiertes Skript",
    WebStringKey.FlagHomograph to "Homograph-Angriff",
    WebStringKey.ClearHistory to "Alles löschen",
    WebStringKey.SectionAttackBreakdown to "Angriffsaufschlüsselung",
    WebStringKey.AttackHomographTitle to "Homograph / IDN-Angriff",
    WebStringKey.AttackHomographDesc to "Kyrillische Zeichen, die das lateinische Alphabet nachahmen, wurden erkannt.",
    WebStringKey.AttackVisualLabel to "Visuelles Erscheinungsbild",
    WebStringKey.AttackPunycodeLabel to "Tatsächlicher Punycode",
    WebStringKey.AttackHomographExplain to "Die Domain verwendet das kyrillische 'а' (U+0430) anstelle des lateinischen 'a' (U+0061). Diese Technik wird häufig verwendet, um Benutzer dazu zu bringen, zu glauben, sie würden einen legitimen Dienst besuchen.",
    WebStringKey.AttackRedirectTitle to "Verdächtige Weiterleitungskette",
    WebStringKey.AttackRedirectDesc to "3 Hops mit bekannten URL-Shortenern erkannt.",
    WebStringKey.RedirectStart to "QR-Code-Scan",
    WebStringKey.RedirectHop to "Zwischen-Hop",
    WebStringKey.RedirectFinal to "Endgültiges Ziel",
    WebStringKey.AttackJsTitle to "Verschleiertes JavaScript",
    WebStringKey.AttackJsDesc to "Zeichenfolge mit hoher Entropie in URL-Parametern erkannt.",
    WebStringKey.SectionActions to "Empfohlene Maßnahmen",
    WebStringKey.ActionBlock to "Blockieren & Melden",
    WebStringKey.ActionBlockDesc to "Zugriff verhindern und Admin benachrichtigen",
    WebStringKey.ActionQuarantine to "In Sandbox isolieren",
    WebStringKey.ActionQuarantineDesc to "Sicher zur Analyse öffnen",
    WebStringKey.Expected to "Erwartet: ",
    WebStringKey.Detected to "Erkannt: ",
    WebStringKey.ExplainableSecurity to "Erklärbare Sicherheit",
    WebStringKey.UrlBreakdown to "URL-AUFSCHLÜSSELUNG",
    WebStringKey.FullUrl to "VOLLSTÄNDIGE URL",
    WebStringKey.OpenInBrowser to "In Browser öffnen (Riskant)",
    WebStringKey.OpenWarning to "Das Öffnen dieser URL in Ihrem Browser kann Sie Sicherheitsrisiken aussetzen.",
    WebStringKey.RestrictedMode to "Eingeschränkter Modus",
    WebStringKey.RestrictedDesc to "Diese URL wurde als potenziell gefährlich markiert. Überprüfen Sie die Analyse unten, bevor Sie fortfahren.",
    WebStringKey.DangerousWarning to "Diese URL wurde als potenziell gefährlich markiert. Das Öffnen kann Sie Phishing, Malware oder anderen Sicherheitsbedrohungen aussetzen. Sind Sie sicher, dass Sie fortfahren möchten?",
    WebStringKey.CopyUrl to "URL kopieren",
    WebStringKey.Share to "Teilen",
    WebStringKey.Dismiss to "Verwerfen",
    WebStringKey.ReasonDomainAge to "Domain-Alter ist weniger als 24 Stunden.",
    WebStringKey.ReasonSignatures to "3 Signaturen in lokaler Phishing-DB gefunden.",
    WebStringKey.ReasonAsn to "Ziel-IP befindet sich in einem risikoreichen ASN.",
    WebStringKey.SectionMeta to "Scan-Metadaten",
    WebStringKey.MetaTime to "Scan-Zeit",
    WebStringKey.MetaSource to "Quelle",
    WebStringKey.MetaEngine to "Engine",
    WebStringKey.MetaOfflineGuaranteeLabel to "Offline-Garantie:",
    WebStringKey.MetaOfflineGuaranteeDesc to "Dieses Bild wurde lokal auf Ihrem Gerät analysiert. Es wurden keine Daten für dieses Urteil an die Cloud gesendet.",
    
    // Results Page
    WebStringKey.ScanComplete to "Scan abgeschlossen",
    WebStringKey.Loading to "Wird geladen...",
    WebStringKey.AnalyzedOffline to "Offline analysiert in <5ms",
    WebStringKey.NoDataLeaves to "Keine Daten verlassen das Gerät",
    WebStringKey.ActiveProtection to "Aktiver Schutz",
    WebStringKey.ConfidenceScore to "Konfidenzwert",
    WebStringKey.Analyzing to "ANALYSIERE...",
    WebStringKey.ProcessingResults to "Scan-Ergebnisse werden verarbeitet...",
    WebStringKey.RiskAssessment to "Risikobewertung",
    WebStringKey.AnalysisTime to "Analysezeit",
    WebStringKey.Heuristics to "Heuristiken",
    WebStringKey.TopAnalysisFactors to "Top-Analysefaktoren",
    WebStringKey.Pass to "BESTANDEN",
    WebStringKey.Info to "INFO",
    WebStringKey.Clean to "SAUBER",
    WebStringKey.ValidSslCertificate to "Gültiges SSL-Zertifikat",
    WebStringKey.SslCertificateDesc to "Zertifikat ausgestellt von DigiCert Inc. Keine Anomalien in der Vertrauenskette.",
    WebStringKey.EstablishedDomain to "Etablierte Domain",
    WebStringKey.EstablishedDomainDesc to "Domain vor > 5 Jahren registriert. Geringe Wahrscheinlichkeit für Betrug.",
    WebStringKey.BlacklistStatus to "Blacklist-Status",
    WebStringKey.BlacklistStatusDesc to "Nicht in 52 lokalen Offline-Bedrohungsdatenbanken gefunden.",
    WebStringKey.BackToDashboard to "Zurück zum Dashboard",
    WebStringKey.ShareReport to "Bericht teilen",
    WebStringKey.CopyLink to "Link kopieren",
    WebStringKey.LinkCopied to "Link in Zwischenablage kopiert!",
    
    // Game Page
    WebStringKey.BeatTheBot to "Beat the Bot",
    WebStringKey.BeatTheBotDesc to "Fordere unsere Offline-KI heraus. Kannst du Phishing schneller erkennen?",
    WebStringKey.SessionId to "Sitzungs-ID",
    WebStringKey.EndSession to "Sitzung beenden",
    WebStringKey.Round to "Runde",
    WebStringKey.BrowserPreview to "Browser-Vorschau",
    WebStringKey.MakeDecision to "Treffe deine Entscheidung",
    WebStringKey.Phishing to "Phishing",
    WebStringKey.Legitimate to "Legitim",
    WebStringKey.LiveHint to "Live-Hinweis",
    WebStringKey.LiveScoreboard to "Live-Anzeigetafel",
    WebStringKey.VsMode to "VS-MODUS",
    WebStringKey.You to "Du",
    WebStringKey.Points to "Pkt",
    WebStringKey.Streak to "Serie",
    WebStringKey.Accuracy to "Genauigkeit",
    WebStringKey.MehrGuardBot to "Mehr Guard Bot",
    WebStringKey.Confidence to "Konfidenz",
    WebStringKey.RoundAnalysis to "Rundenanalyse",
    WebStringKey.Analysis to "Analyse",
    WebStringKey.CorrectDecision to "Richtige Entscheidung!",
    WebStringKey.IdentifiedSafe to "Du hast die sichere URL korrekt identifiziert.",
    WebStringKey.AiNeuralAnalysis to "KI-Neurale Analyse",
    WebStringKey.WhyBotFlagged to "Warum der Bot es markiert hat",
    WebStringKey.EducationalNote to "Lernhinweis",
    WebStringKey.Correct to "Richtig!",
    WebStringKey.SpottedPhishing to "Du hast die Phishing-URL korrekt erkannt.",
    WebStringKey.Response to "Antwort",
    WebStringKey.NextRound to "Nächste Runde",
    WebStringKey.GameOver to "Spiel beendet!",
    WebStringKey.FinalResults to "Endergebnisse",
    WebStringKey.YourScore to "Deine Punktzahl",
    WebStringKey.BotScore to "Bot-Punktzahl",
    WebStringKey.BestStreak to "Beste Serie",
    WebStringKey.PlayAgain to "Nochmal spielen",
    WebStringKey.ReturnToDashboard to "Zurück zum Dashboard",
    
    // Export Page
    WebStringKey.ExportSecurityReport to "Sicherheitsbericht exportieren",
    WebStringKey.GenerateReport to "Erstelle umfassende Sicherheitsberichte aus deinem Scanverlauf.",
    WebStringKey.ReportFormat to "Berichtsformat",
    WebStringKey.HumanReadable to "Menschenlesbarer Bericht",
    WebStringKey.HumanReadableDesc to "PDF mit visueller Aufschlüsselung und Zusammenfassung",
    WebStringKey.MachineReadable to "Maschinenlesbare Daten",
    WebStringKey.MachineReadableDesc to "JSON-Format für SIEM-Integration",
    WebStringKey.DateRange to "Datumsbereich",
    WebStringKey.Last7Days to "Letzte 7 Tage",
    WebStringKey.Last30Days to "Letzte 30 Tage",
    WebStringKey.Last90Days to "Letzte 90 Tage",
    WebStringKey.AllTime to "Gesamter Zeitraum",
    WebStringKey.CustomRange to "Benutzerdefinierter Bereich",
    WebStringKey.ReportSections to "Berichtsabschnitte",
    WebStringKey.ExecutiveSummary to "Zusammenfassung",
    WebStringKey.ThreatBreakdown to "Bedrohungsaufschlüsselung",
    WebStringKey.ScanTimeline to "Scan-Zeitachse",
    WebStringKey.SafeUrlList to "Liste sicherer URLs",
    WebStringKey.GenerateExport to "Bericht exportieren",
    
    // Toast / Notifications
    WebStringKey.Success to "Erfolg!",
    WebStringKey.Error to "Fehler",
    WebStringKey.Warning to "Warnung",
    WebStringKey.CopiedToClipboard to "In Zwischenablage kopiert",
    
    // General Actions
    WebStringKey.Cancel to "Abbrechen",
    WebStringKey.Confirm to "Bestätigen",
    WebStringKey.Save to "Speichern",
    WebStringKey.Delete to "Löschen",
    WebStringKey.Edit to "Bearbeiten",
    WebStringKey.Close to "Schließen",
    WebStringKey.Back to "Zurück",
    WebStringKey.Next to "Weiter",
    WebStringKey.Previous to "Zurück",
    WebStringKey.Submit to "Absenden",
    WebStringKey.Reset to "Zurücksetzen",
    WebStringKey.Clear to "Leeren",
    WebStringKey.Search to "Suchen",
    WebStringKey.Filter to "Filtern",
    WebStringKey.Sort to "Sortieren",
    
    // Accessibility
    WebStringKey.ToggleMenu to "Menü umschalten",
    WebStringKey.ToggleTheme to "Design umschalten",
    WebStringKey.Notifications to "Benachrichtigungen",
    WebStringKey.Help to "Hilfe",
    WebStringKey.Profile to "Profil",
    WebStringKey.ToggleLightDarkMode to "Hell/Dunkel-Modus umschalten",
    
    // Placeholders
    WebStringKey.UrlInputPlaceholder to "URL zum Analysieren einfügen (z.B. https://example.com)",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    
    // Export Page Additional
    WebStringKey.Scan to "Scannen",
    WebStringKey.Result to "Ergebnis",
    WebStringKey.ReportGeneration to "Berichtserstellung",
    WebStringKey.ReportGenerationDesc to "Formate konfigurieren und Bedrohungsanalyse herunterladen.",
    WebStringKey.OfflineSecurity to "Offline-Sicherheit",
    WebStringKey.OfflineSecurityDesc to "Ihre Daten verlassen dieses Gerät nie. Alle Verarbeitung ist lokal.",
    WebStringKey.ChooseFormat to "Format wählen",
    WebStringKey.PdfFormatDesc to "PDF-Format. Am besten zum Teilen.",
    WebStringKey.JsonFormatDesc to "JSON-Format. Am besten für SIEM-Integration.",
    WebStringKey.Copy to "Kopieren",
    WebStringKey.LivePreview to "Live-Vorschau",
    WebStringKey.ReadOnly to "Nur Lesen",
    WebStringKey.ThreatAnalysisReport to "Bedrohungsanalysebericht",
    WebStringKey.Verdict to "Urteil",
    WebStringKey.RiskScore to "Risikobewertung",
    WebStringKey.TargetUrl to "Ziel-URL",
    WebStringKey.AnalysisSummaryLabel to "Analyse-Zusammenfassung",
    WebStringKey.TechnicalIndicators to "Technische Indikatoren",
    WebStringKey.ExportInfoNote to "Exporte enthalten alle identifizierten Bedrohungsvektoren und die Payload-Analyse.",
    
    // Trust Centre Page
    WebStringKey.AllowList to "Erlaubnisliste",
    WebStringKey.BlockList to "Sperrliste",
    WebStringKey.AddDomain to "Domain hinzufügen",
    WebStringKey.RemoveDomain to "Domain entfernen",
    WebStringKey.TrustedDomains to "Vertrauenswürdige Domains",
    WebStringKey.BlockedDomains to "Blockierte Domains",
    WebStringKey.DomainPlaceholder to "Domain eingeben (z.B. example.com)",
    
    // Game Page Additional
    WebStringKey.Safe to "Sicher",
    WebStringKey.TimeAgo to "vor",
    WebStringKey.MinutesAgo to "Min. zuvor",
    WebStringKey.HoursAgo to "Std. zuvor",
    
    // Misc
    WebStringKey.Critical to "KRITISCH",
    WebStringKey.Warn to "WARNUNG",
    
    // Trust Centre - Sensitivity
    WebStringKey.PhishingDetectionSensitivity to "Phishing-Erkennungsempfindlichkeit",
    WebStringKey.SensitivityDescription to "Heuristische Schwellenwerte anpassen. Höhere Empfindlichkeit kann Fehlalarme erhöhen.",
    WebStringKey.SensitivityLow to "Niedrig",
    WebStringKey.SensitivityBalanced to "Ausgewogen",
    WebStringKey.SensitivityParanoia to "Paranoid",
    WebStringKey.BalancedModeRecommended to "Ausgewogener Modus (Empfohlen)",
    WebStringKey.BalancedModeDesc to "Sucht nach bekannten bösartigen Mustern und heuristischen Abweichungen. Blockiert Homoglyphen-Angriffe und Weiterleitungsketten.",
    WebStringKey.LowSensitivityMode to "Modus mit niedriger Empfindlichkeit",
    WebStringKey.LowSensitivityModeDesc to "Blockiert nur bekannte bösartige URLs aus der Bedrohungsdatenbank. Minimale Fehlalarme, kann aber neue Angriffe übersehen.",
    WebStringKey.ParanoiaMode to "Paranoia-Modus",
    WebStringKey.ParanoiaModeDesc to "Maximaler Schutz. Blockiert alle verdächtigen Muster einschließlich neu registrierter Domains, ungewöhnlicher TLDs und URLs mit potenziellen Kodierungstricks.",
    WebStringKey.PrivacyGuaranteeDesc to "Mehr Guard verwendet lokale heuristische Analyse-Engines. Keine Bilddaten, URL-Strings oder Metadaten verlassen dieses Gerät während des Scans. Ihre Privatsphäre ist mathematisch garantiert.",
    WebStringKey.SignalBrandImpersonation to "Potenzielle Markenimitation erkannt",
    WebStringKey.SignalCredentialParams to "Anmeldebezogene Parameter in URL",
    WebStringKey.SignalEncodedPayload to "Kodierte Daten in Query-Parametern erkannt",
    WebStringKey.SignalExcessiveSubdomains to "Übermäßige Subdomain-Tiefe ({count} Ebenen)",
    WebStringKey.SignalHighEntropyHost to "Hohe Zufälligkeit im Domainnamen",
    WebStringKey.SignalHomographAttack to "Domain enthält Homoglyphen/verwechselbare Zeichen",
    WebStringKey.SignalHttpNotHttps to "Verwendet unsicheres HTTP-Protokoll",
    WebStringKey.SignalIpAddressHost to "Host ist eine IP-Adresse statt einer Domain",
    WebStringKey.SignalLongUrl to "Ungewöhnlich lange URL ({length} Zeichen)",
    WebStringKey.SignalLongUrlMarketing to "Ungewöhnlich lange URL ({length} Zeichen) - enthält Marketing-Parameter",
    WebStringKey.SignalNewlyRegisteredDomain to "Neu registrierte Domain erkannt",
    WebStringKey.SignalNonStandardPort to "Nicht-Standard-Port: {port}",
    WebStringKey.SignalNumericSubdomain to "Nur numerische Subdomain erkannt",
    WebStringKey.SignalSuspiciousPathKeywords to "Verdächtige Schlüsselwörter im Pfad ({count} gefunden)",
    WebStringKey.SignalSuspiciousTld to "Verdächtige TLD: {tld}",
    WebStringKey.SignalUrlShortener to "Verwendet URL-Verkürzungsdienst",
    WebStringKey.SecureEnvironment to "Sichere Umgebung",
    WebStringKey.LearnLocalArchitecture to "Erfahre mehr über unsere lokale Architektur",
    WebStringKey.NoCustomDomainsBlocked to "Keine benutzerdefinierten Domains blockiert.",
    WebStringKey.AddManually to "Manuell hinzufügen",
    WebStringKey.AddedDaysAgo to "Vor 2 Tagen hinzugefügt",
    WebStringKey.AddedWeekAgo to "Vor 1 Woche hinzugefügt",
    
    // Trust Centre - Privacy Controls
    WebStringKey.PrivacyControls to "Datenschutzkontrollen",
    WebStringKey.StrictOfflineMode to "Strikter Offline-Modus",
    WebStringKey.DisableExternalPreviews to "Alle externen Link-Vorschauen deaktivieren.",
    WebStringKey.AnonymousTelemetry to "Anonyme Telemetrie",
    WebStringKey.ShareDetectionStats to "Erkennungsstatistiken teilen um ML zu verbessern.",
    WebStringKey.AutoCopySafeLinks to "Sichere Links automatisch kopieren",
    WebStringKey.CopyTrustedUrls to "Vertrauenswürdige URLs in Zwischenablage kopieren.",
    
    // Trust Centre - About
    WebStringKey.AboutMehrGuard to "Über Mehr Guard",
    WebStringKey.OpenSourceLicenses to "Open-Source-Lizenzen",
    WebStringKey.PrivacyPolicy to "Datenschutzrichtlinie",
    WebStringKey.Acknowledgements to "Danksagungen",
    WebStringKey.ResetAllSettings to "Alle Einstellungen zurücksetzen",
    WebStringKey.AddToAllowlist to "Zur Erlaubnisliste hinzufügen",
    WebStringKey.AddToBlocklist to "Zur Sperrliste hinzufügen",
    
    // Onboarding
    WebStringKey.AnalysedOfflineTitle to "Offline analysiert.",
    WebStringKey.YourDataStaysOnDevice to "Ihre Daten bleiben auf dem Gerät.",
    WebStringKey.OnboardingHeroDesc to "Mehr Guard verarbeitet jeden Scan mit sicherer On-Device-Analyse. Wir priorisieren erklärbare Sicherheit ohne Cloud-Telemetrie.",
    WebStringKey.OnDeviceAnalysis to "On-Device-Analyse",
    WebStringKey.OnDeviceAnalysisDesc to "Alle Bedrohungserkennung läuft lokal auf Ihrem Gerät. Keine Daten verlassen Ihr System.",
    WebStringKey.NoCloudLogs to "Keine Cloud-Logs",
    WebStringKey.NoCloudLogsDesc to "Wir deaktivieren strikt ausgehende Telemetrie für Scans. Scan-Ergebnisse und Bild-Hashes bleiben lokal.",
    WebStringKey.OnDeviceDB to "On-Device-Datenbank",
    WebStringKey.OnDeviceDBDesc to "Die gesamte Bedrohungssignatur-Datenbank wird auf Ihr Gerät für Millisekunden-Lookups heruntergeladen.",
    WebStringKey.DataLifecycleVerification to "Datenlebenszyklus-Verifizierung",
    WebStringKey.SecurityAuditPass to "Sicherheitsaudit: BESTANDEN",
    
    // Footer
    WebStringKey.Copyright to "© 2024 Mehr Guard Security Inc. Alle Rechte vorbehalten.",
    WebStringKey.Support to "Unterstützung",
    WebStringKey.Terms to "Bedingungen",
    WebStringKey.SystemsOperational to "Systeme betriebsbereit",
    WebStringKey.SystemSecure to "System sicher",
    
    // Version / Build Info
    WebStringKey.VersionStatus to "v2.4.1 • System sicher",
    WebStringKey.CoreVersion to "Core v2.4.1 • Build 2025.12.29",
    WebStringKey.VerifiedBy to "Verifiziert durch Mehr Guard Enterprise",
    
    // User Profile (Sample)
    WebStringKey.SampleUserName to "Max Mustermann",
    WebStringKey.SampleUserRole to "Sicherheitsanalyst",
    
    // Export Preview
    WebStringKey.DetailLabel to "Detail-Bezeichnung",
    WebStringKey.DetailValue to "Detail-Wert",
    WebStringKey.Suspicious to "Verdächtig",
    
    // Game Modal Strings
    WebStringKey.IncorrectDecision to "Falsche Entscheidung",
    WebStringKey.WrongAnswer to "Ups! Das war nicht richtig.",
    WebStringKey.ResponseTime to "Antwortzeit",
    WebStringKey.IncomingMessage to "Eingehende Nachricht",
    WebStringKey.CertificateIssuer to "Zertifikataussteller entspricht Domain-Besitzer",
    WebStringKey.DomainAgeTrust to "Domain-Alter > 5 Jahre (Hohes Vertrauen)",
    WebStringKey.WhitelistedRank to "Top 1k Alexa-Rang lokal auf Whitelist",
    
    // Game Tips/Hints
    WebStringKey.GameEducationalNote to "Lernhinweis",
    WebStringKey.GameHintTitle to "Spieltipp",
    
    // Trust Modal
    WebStringKey.AddToAllowlistTitle to "Zur Erlaubnisliste hinzufügen",
    WebStringKey.AddToBlocklistTitle to "Zur Sperrliste hinzufügen",
    WebStringKey.EnterDomainPrompt to "Domain eingeben um zur Liste hinzuzufügen",
    
    // Additional Game Strings
    WebStringKey.LatencyMs to "Latenz",
    WebStringKey.StreakFire to "Serie",
    WebStringKey.AccuracyPercent to "Genauigkeit",
    WebStringKey.ConfidencePercent to "Konfidenz",
    
    // Languages
    WebStringKey.English to "Englisch",
    WebStringKey.German to "Deutsch",
    WebStringKey.Spanish to "Spanisch",
    WebStringKey.French to "Französisch",
    WebStringKey.ChineseSimplified to "Chinesisch (Vereinfacht)",
    WebStringKey.Japanese to "Japanisch",
    WebStringKey.Hindi to "Hindi",
    WebStringKey.Arabic to "Arabisch",
    WebStringKey.Indonesian to "Indonesisch",
    WebStringKey.Italian to "Italienisch",
    WebStringKey.Korean to "Koreanisch",
    WebStringKey.Portuguese to "Portugiesisch",
    WebStringKey.Russian to "Russisch",
    WebStringKey.Thai to "Thailändisch",
    WebStringKey.Turkish to "Türkisch",
    WebStringKey.Vietnamese to "Vietnamesisch"
,
    WebStringKey.ComponentVoting to "Komponenten-Abstimmung",
    WebStringKey.Heuristic to "Heuristik",
    WebStringKey.MLModel to "ML-Modell",
    WebStringKey.Brand to "Marke",
    WebStringKey.TLD to "TLD",
    WebStringKey.VotingExplanation to "Mehrheitsvotum bestimmt Urteil: 3+ SICHER = grün, 2+ BÖSARTIG = rot"
,
    // Results Page Placeholders,
    WebStringKey.WaitingForScan to "Warten auf Scan...",
    WebStringKey.WaitingForAnalysis to "Warten auf Analyse...",
    WebStringKey.ScanURLToSeeResults to "Scannen Sie eine URL, um detaillierte Ergebnisse zu sehen.",

    // Keyboard Shortcuts & Settings
    WebStringKey.KeyboardShortcuts to "Tastaturkürzel",
    WebStringKey.StartScanner to "Scanner starten",
    WebStringKey.CloseMenuModal to "Menü / Modal schließen",
    WebStringKey.NavigateToDashboard to "Zum Dashboard navigieren",
    WebStringKey.NavigateToHistory to "Scan-Verlauf",
    WebStringKey.NavigateToTrust to "Vertrauenszentrum / Freigabeliste",
    WebStringKey.NavigateToGame to "Beat the Bot Spiel",
    WebStringKey.ShowHelp to "Hilfe anzeigen",
    WebStringKey.GotIt to "Verstanden",
    WebStringKey.SecuritySettings to "Sicherheitseinstellungen",
    WebStringKey.SensitivityLevel to "Empfindlichkeitsstufe",
    WebStringKey.AutoBlockThreats to "Bedrohungen automatisch blockieren",
    WebStringKey.RealTimeScanning to "Echtzeit-Scan",
    WebStringKey.SoundAlerts to "Akustische Warnungen",
    WebStringKey.ThreatAlerts to "Bedrohungswarnungen",
    WebStringKey.ShowConfidenceScore to "Konfidenzwert anzeigen",
    WebStringKey.CompactView to "Kompaktansicht",
    WebStringKey.ResetDefaults to "Standardwerte zurücksetzen",
    WebStringKey.SaveAndContinue to "Speichern & Fortfahren",

    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "Über Mehr Guard Security",
    WebStringKey.ActualDomain to "Tatsächliche Domain",
    WebStringKey.AnalysisComplete to "Analyse abgeschlossen",
    WebStringKey.AutoBlockThreatsDesc to "Bedrohungen automatisch blockieren",
    WebStringKey.AwaitingScanLabel to "Warte auf Scan",
    WebStringKey.BrandImpersonation to "Markenimitation",
    WebStringKey.CautionAdvised to "Vorsicht empfohlen",
    WebStringKey.CompactViewDesc to "Kompakte Ansicht",
    WebStringKey.DoNotVisit to "NICHT BESUCHEN",
    WebStringKey.DoNotVisitDesc to "Hochsicheres Phishing erkannt. Diese URL zeigt mehrere bösartige Indikatoren.",
    WebStringKey.DomainUsesInternationalChars to "Diese Domain verwendet internationale Zeichen, die legitime Domains imitieren könnten.",
    WebStringKey.GoToScanner to "Zum Scanner",
    WebStringKey.Hebrew to "Hebräisch",
    WebStringKey.HelpKeyboardShortcuts to "Tastenkürzel",
    WebStringKey.HeuristicAnalysis to "Heuristische Analyse",
    WebStringKey.HeuristicAnalysisDesc to "URL wurde basierend auf mehreren von der Analyse-Engine erkannten Risikofaktoren markiert.",
    WebStringKey.HiddenDestination to "Verstecktes Ziel",
    WebStringKey.HighRisk to "Hohes Risiko",
    WebStringKey.HighRiskLabel to "HOHES RISIKO",
    WebStringKey.HomographIdnAttack to "Homograph / IDN-Angriff",
    WebStringKey.InternationalizedDomainDetected to "Internationalisierter Domainname erkannt.",
    WebStringKey.JustNow to "Gerade eben",
    WebStringKey.KeyboardShortcutsDesc to "Tastenkürzel für schnellen Zugriff",
    WebStringKey.LiveFeedActive to "LIVE-FEED AKTIV",
    WebStringKey.LowRisk to "Geringes Risiko",
    WebStringKey.LowRiskLabel to "GERINGES RISIKO",
    WebStringKey.Malicious to "Bösartig",
    WebStringKey.MediumRiskLabel to "MITTLERES RISIKO",
    WebStringKey.NoData to "KEINE DATEN",
    WebStringKey.NoScanDataResults to "Keine Scandaten verfügbar. Bitte scannen Sie eine URL, um Analyseergebnisse zu sehen.",
    WebStringKey.NoUrlScanned to "Keine URL gescannt",
    WebStringKey.Persian to "Persisch",
    WebStringKey.PhishingIndicators to "Phishing-Indikatoren",
    WebStringKey.ProceedWithCaution to "MIT VORSICHT FORTFAHREN",
    WebStringKey.ProceedWithCautionDesc to "Einige verdächtige Indikatoren erkannt. Überprüfen Sie die Quelle, bevor Sie sensible Informationen eingeben.",
    WebStringKey.RealTimeScanningDesc to "Echtzeit-Scanning",
    WebStringKey.RedirectShortenerDetected to "Weiterleitung/Verkürzung erkannt",
    WebStringKey.SafeToVisit to "SICHER ZU BESUCHEN",
    WebStringKey.SafeToVisitDesc to "Verifiziert durch lokale Heuristik v2.4. Keine Phishing-Muster, verschleierte Skripte oder Blacklist-Treffer gefunden.",
    WebStringKey.SafetyScore to "Sicherheitsbewertung",
    WebStringKey.ScanCompleteLabel to "Scan abgeschlossen",
    WebStringKey.ScanToAnalyze to "Scannen Sie einen QR-Code oder geben Sie eine URL zur Analyse ein.",
    WebStringKey.ScannedURLLabel to "Gescannte URL",
    WebStringKey.SecuritySignal to "Sicherheitssignal",
    WebStringKey.SensitivityLevelDesc to "Empfindlichkeitsstufe",
    WebStringKey.SensitivityPermissive to "Tolerant",
    WebStringKey.SensitivityStrict to "Streng",
    WebStringKey.SettingsDetection to "Erkennung",
    WebStringKey.SettingsDisplay to "Anzeige",
    WebStringKey.SettingsLanguage to "Sprache",
    WebStringKey.SettingsLanguageDesc to "UI-Sprache auswählen",
    WebStringKey.SettingsNotifications to "Benachrichtigungen",
    WebStringKey.SettingsSavedAutomatically to "Einstellungen werden automatisch gespeichert und sitzungsübergreifend synchronisiert.",
    WebStringKey.ShowConfidenceScoreDesc to "Konfidenzwert anzeigen",
    WebStringKey.SoundAlertsDesc to "Akustische Warnungen",
    WebStringKey.SuspiciousDomain to "Verdächtige Domain",
    WebStringKey.SuspiciousEncoding to "Verdächtige Kodierung",
    WebStringKey.SuspiciousKeywords to "Verdächtige Schlüsselwörter",
    WebStringKey.SuspiciousTld to "Verdächtige TLD",
    WebStringKey.SuspiciousTldDesc to "Domain verwendet {tld} TLD, die häufig mit bösartigen Websites verbunden ist.",
    WebStringKey.SuspiciousUrlParams to "Verdächtige URL-Parameter",
    WebStringKey.SuspiciousUrlParamsDesc to "URL enthält komplexe oder möglicherweise verschleierte Parameter.",
    WebStringKey.ThreatAlertsDesc to "Bedrohungswarnungen",
    WebStringKey.ThreatDetected to "Bedrohung erkannt",
    WebStringKey.UnableToDetermine to "Urteil konnte nicht bestimmt werden. Bitte versuchen Sie es erneut.",
    WebStringKey.Unknown to "Unbekannt",
    WebStringKey.UnknownURL to "Unbekannte URL",
    WebStringKey.UrlShortenerDesc to "URL verwendet einen Verkürzungsdienst, der das endgültige Ziel verbirgt.",
    WebStringKey.UrlShortenerDetected to "URL-Verkürzung erkannt",
    WebStringKey.VersionOfflineReady to "Offline bereit",
    WebStringKey.VisualAppearance to "Visuelles Erscheinungsbild",
    WebStringKey.WaitingForAnalysisLabel to "Warte auf Analyse..."
)

internal val GermanCommonStrings = mapOf(
    "\"Always expand short links before scanning. The bot does this automatically by following redirect headers without rendering the page.\"" to "„Erweitern Sie vor dem Scannen immer kurze Links. Der Bot folgt dabei automatisch den Redirect-Headern, ohne die Seite zu rendern.“",
    "\"AusPost: Your parcel failed delivery due to incorrect address details. Please update immediately via the link above to avoid return.\"" to "„AusPost: Ihr Paket konnte aufgrund falscher Adressangaben nicht zugestellt werden. Bitte aktualisieren Sie es sofort über den Link oben, um Rücksendungen zu vermeiden.“",
    "\"Commonwealth Bank: Your account has been locked due to suspicious activity. Verify your identity immediately.\"" to "“Commonwealth Bank: Ihr Konto wurde aufgrund verdächtiger Aktivitäten gesperrt. Überprüfen Sie sofort Ihre Identität.“",
    "\"Let's Encrypt (R3)\"" to "“Let's Encrypt (R3)\"",
    "\"Phishing\"" to "\"Phishing\"",
    "\"You won a \$500 gift card! Click to claim your prize.\"" to "\"Sie haben eine Geschenkkarte im Wert von 500 \$ gewonnen!\"",
    "\"Your Apple ID was used to sign in on a new device. If this was not you, verify immediately.\"" to "\"Ihre Apple-ID wurde für die Anmeldung auf einem neuen Gerät verwendet. Wenn dies nicht der Fall war, bestätigen Sie dies sofort.\"",
    "\"Your PayPal account has been limited. Please update your information.\"" to "\"Ihr PayPal-Konto wurde eingeschränkt.“",
    "+10-15 points — Context-dependent signal" to "+10-15 Punkte — Kontextabhängiges Signal",
    "+10-15 points — Suggestive but not conclusive" to "+10-15 Punkte – Suggestiv, aber nicht schlüssig",
    "+10-15 points — Suspicious but not definitive" to "+10-15 Punkte – Verdächtig, aber nicht definitiv",
    "+10-20 points — Contributes to overall risk score" to "+10-20 Punkte – Trägt zur Gesamtrisikobewertung bei",
    "+15-20 points — Requires caution, not definitive" to "+15-20 Punkte – Erfordert Vorsicht, nicht definitiv",
    "+15-20 points — Requires destination inspection" to "+15-20 Punkte – Zielortüberprüfung erforderlich",
    "+15-20 points — Security baseline not met" to "+15–20 Punkte – Sicherheitsgrundlinie nicht erfüllt",
    "+20-30 points — Deliberate deception technique" to "+20–30 Punkte – Absichtliche Täuschungstechnik",
    "+20-30 points — Legitimate brands rarely use these" to "+20–30 Punkte – Seriöse Marken verwenden diese selten",
    "+25-30 points — Strong phishing indicator" to "+25–30 Punkte – Starker Phishing-Indikator",
    "+30-35 points — Requires investigation of actual characters" to "+30–35 Punkte – Erfordert Untersuchung tatsächlicher Zeichen",
    "+30-40 points — This is a primary phishing indicator" to "+30-40 Punkte – Dies ist ein primärer Phishing-Indikator",
    "+40-50 points — Advanced attack requiring intentional deception" to "+40-50 Punkte – Fortgeschrittener Angriff, der absichtliche Täuschung erfordert",
    "+5-10 points — Minor signal" to "+5-10 Punkte – Geringfügiges Signal",
    "- Heuristics: {list}" to "- Heuristik: {list}",
    "- Redirects: {count}" to "- Weiterleitungen: {count}",
    "- SSL Issuer: {issuer}" to "- SSL-Aussteller: {issuer}",
    "- Threat Type: {type}" to "- Bedrohungstyp: {type}",
    "1 hr ago • Phishing" to "vor 1 Stunde • Phishing",
    "100% offline" to "100 % offline",
    "2 hours ago" to "vor 2 Stunden",
    "2 mins ago • Safe" to "vor 2 Minuten • Sicher",
    "25+ AI Heuristics" to "25+ AI Heuristik",
    "3 hops detected involving known URL shorteners." to "3 Hops mit bekannten URL-Shortenern erkannt.",
    "3 hrs ago • Safe" to "vor 3 Stunden • Sicher",
    "350 pts" to "350 Punkte",
    "400 pts" to "400 Punkte",
    "5 hrs ago • Safe" to "vor 5 Stunden • Sicher",
    "< 24 hours" to "< 24 Stunden",
    "A phishing attempt was successfully blocked" to "Ein Phishing-Versuch war erfolgreich blockiert",
    "A shorter, cleaner URL would reduce this signal contribution by ~8 points." to "Eine kürzere, sauberere URL würde diesen Signalbeitrag um ~8 Punkte reduzieren.",
    "AD" to "AD",
    "AI-powered phishing detection running 100% offline in your browser." to "KI-gestützte Phishing-Erkennung läuft zu 100 % offline in Ihrem Browser.",
    "AI-powered phishing detection that runs" to "KI-gestützte Phishing-Erkennung läuft",
    "AM" to "AM",
    "About Mehr Guard" to "Über [[MARKE]]",
    "Accuracy" to "Genauigkeit",
    "Accuracy:" to "Genauigkeit:",
    "Acknowledgements" to "Danksagungen",
    "Active" to "Aktiv",
    "Active Protection" to "Aktiver Schutz",
    "Active Scanner" to "Aktiver Scanner",
    "Actual Punycode (Where it goes)" to "Tatsächlicher Punycode (wo er hingehört)",
    "Add Domain" to "Hinzufügen Domäne",
    "Add manually" to "Manuell hinzufügen",
    "Add to Allowlist" to "Zur Zulassungsliste hinzufügen",
    "Add to Blocklist" to "Zur Sperrliste hinzufügen",
    "Added 1 week ago" to "Vor 1 Woche hinzugefügt",
    "Added 2 days ago" to "Vor 2 Tagen hinzugefügt",
    "Added {domain} to {list}" to "{domain} zu {list} hinzugefügt",
    "Adjust heuristic thresholds. Higher sensitivity may increase false positives." to "Heuristische Schwellenwerte anpassen. Eine höhere Empfindlichkeit kann zu einer Zunahme falsch positiver Ergebnisse führen.",
    "Alex Chen" to "Alex Chen",
    "Alex Morgan" to "Alex Morgan",
    "Alexa Top 1000 site" to "Alexa Top 1000-Site",
    "All URLs will show as MALICIOUS for demo purposes" to "Alle URLs werden zu Demozwecken als SCHÄDLICH angezeigt",
    "All code execution happens in an ephemeral container that is destroyed after each scan. This ensures malicious payloads can never escape to your system." to "Die gesamte Codeausführung erfolgt in einem kurzlebigen Container, der nach jedem Scan zerstört wird. Dadurch wird sichergestellt, dass schädliche Payloads niemals in Ihr System gelangen können.",
    "All notifications marked as read" to "Alle als gelesen markierten Benachrichtigungen",
    "Allow List" to "Zulassungsliste",
    "Allowlist" to "Zulassungsliste",
    "Analysed offline." to "Offline analysiert.",
    "Analysis" to "Analyse",
    "Analysis Complete" to "Analyse abgeschlossen",
    "Analysis Engine Loading..." to "Analyse-Engine Wird geladen...",
    "Analysis Summary" to "Analysezusammenfassung",
    "Analysis Time" to "Analysezeit",
    "Analyze" to "Analysieren",
    "Analyze This URL" to "Diese URL analysieren",
    "Analyze URL" to "URL analysieren",
    "Analyzed offline in <5ms" to "Offline analysiert in <5 ms",
    "Analyzing offline..." to "Offline analysiert...",
    "Anonymous Telemetry" to "Anonym Telemetrie",
    "Anonymous Telemetry disabled" to "Anonyme Telemetrie deaktiviert",
    "Anonymous Telemetry enabled" to "Anonyme Telemetrie aktiviert",
    "Apple Support" to "Apple-Support",
    "Apple only uses apple.com for all account-related activities. Be wary of domains containing brand names but with different extensions." to "Apple verwendet apple.com nur für alle kontobezogenen Aktivitäten. Seien Sie vorsichtig bei Domains, die Markennamen, aber mit unterschiedlichen Endungen enthalten.",
    "Apple would never use a third-party domain for account verification. Check the actual domain name." to "Apple würde niemals eine Drittanbieter-Domain zur Kontobestätigung verwenden. Überprüfen Sie den tatsächlichen Domänennamen.",
    "Are you sure you want to end this session? Progress will be lost." to "Sind Sie sicher, dass Sie diese Sitzung beenden möchten? Fortschritte gehen verloren.",
    "Atlassian" to "Atlassian",
    "Atlassian is a legitimate software company. Their primary domain atlassian.com is trustworthy." to "Atlassian ist ein seriöses Softwareunternehmen. Ihre primäre Domain atlassian.com ist vertrauenswürdig.",
    "Attack Breakdown" to "Angriffsaufschlüsselung",
    "Attackers create domains that look like trusted brands to steal credentials" to "Angreifer erstellen Domains, die wie vertrauenswürdige Marken aussehen, um Anmeldeinformationen zu stehlen",
    "Auto-Block Threats" to "Bedrohungen automatisch blockieren",
    "Auto-Copy Safe Links" to "Sichere Links automatisch kopieren",
    "Auto-Copy Safe Links disabled" to "Sichere Links automatisch kopieren deaktiviert",
    "Auto-Copy Safe Links enabled" to "Sichere Links automatisch kopieren aktiviert",
    "Automatically block high-risk URLs" to "Hochrisiko-URLs automatisch blockieren",
    "Back online" to "Wieder online",
    "Back to Dashboard" to "Zurück zum Dashboard",
    "Balanced" to "Ausgewogen",
    "Balanced Mode (Recommended)" to "Ausgewogener Modus (empfohlen)",
    "Beat the Bot" to "Beat the Bot",
    "Beat the Bot →" to "Beat the Bot →",
    "Best Streak" to "Best Streak",
    "Blacklist Match" to "Blacklist Match",
    "Blacklist Status" to "Blacklist-Status",
    "Block & Report" to "Blockieren & Melden",
    "Blocklist" to "Blocklist",
    "Bot Score" to "Bot Score",
    "Brand Impersonation" to "Markenidentitätswechsel",
    "Brand Impersonation Detected" to "Markenidentitätsbetrug Erkannt",
    "Brands Detected" to "Erkannte Marken",
    "Browser Preview" to "Browservorschau",
    "Built for" to "Erstellt für",
    "CLEAN" to "REINIG",
    "CRITICAL" to "KRITISCH",
    "Camera API (QR scanning unavailable)" to "Kamera-API (QR-Scanning nicht verfügbar)",
    "Camera Access Required" to "Kamerazugriff erforderlich",
    "Camera Not Available" to "Kamera nicht Verfügbar",
    "Camera activated" to "Kamera aktiviert",
    "Camera error: {error}" to "Kamerafehler: {error}",
    "Camera not supported in this browser" to "Kamera wird in diesem Browser nicht unterstützt",
    "Camera permission denied" to "Kameraberechtigung verweigert",
    "Can redirect through tracking or to malicious destinations" to "Kann durch Tracking oder zu böswilligen Zielen umgeleitet werden",
    "Cancel" to "Abbrechen",
    "Caution" to "Achtung",
    "Caution Advised" to "Achtung Empfohlen",
    "Certificate Issuer matches domain owner (DigiCert Inc)" to "Zertifikataussteller entspricht Domänenbesitzer (DigiCert Inc)",
    "Certificate Issuer matches domain owner (DigiCert Inc)." to "Zertifikataussteller entspricht Domänenbesitzer (DigiCert Inc).",
    "Certificate issued by DigiCert Inc. No anomalies in chain of trust." to "Zertifikat ausgestellt von DigiCert Inc. Keine Anomalien in der Vertrauenskette.",
    "Certificate issued by trusted CA. No anomalies in chain of trust." to "Zertifikat ausgestellt von vertrauenswürdiger Zertifizierungsstelle. Keine Anomalien in der Vertrauenskette.",
    "Certificate recently issued or self-signed. Proceed with caution." to "Zertifikat kürzlich ausgestellt oder selbstsigniert. Gehen Sie vorsichtig vor.",
    "Challenge our offline AI engine. Can you spot the phish faster?" to "Fordern Sie unsere Offline-KI-Engine heraus. Können Sie den Phish schneller erkennen?",
    "Characters like Cyrillic \"а\" look identical to Latin \"a\" but are different" to "Zeichen wie das kyrillische „а“ sehen genauso aus wie das lateinische „a“, unterscheiden sich aber",
    "Check for Updates" to "Nach Updates suchen",
    "Check the domain carefully. This appears to be a well-known, trusted domain." to "Überprüfen Sie die Domain sorgfältig. Dies scheint eine bekannte, vertrauenswürdige Domäne zu sein.",
    "Choose Format" to "Format wählen",
    "Clear All" to "Alle löschen",
    "Clear History" to "Verlauf löschen",
    "Clear scan history?" to "Scanverlauf löschen?",
    "Click a sample below or paste any URL:" to "Klicken Sie unten auf ein Beispiel oder fügen Sie eine beliebige URL ein:",
    "Close" to "Schließen",
    "Code execution happens in an ephemeral container. Malicious payloads never touch your OS kernel." to "Die Codeausführung erfolgt in einem kurzlebigen Container. Schädliche Payloads berühren niemals Ihren Betriebssystemkernel.",
    "Combined with other signals, suggests intent to steal credentials" to "In Kombination mit anderen Signalen deutet dies auf die Absicht hin, Anmeldeinformationen zu stehlen.",
    "Compact View" to "Kompakte Ansicht",
    "Compact view" to "Kompakte Ansicht",
    "Complete analysis is performed locally. Your camera feed and scanned data never touch an external server, ensuring absolute privacy." to "Die vollständige Analyse wird lokal durchgeführt. Ihr Kamera-Feed und Ihre gescannten Daten berühren niemals einen externen Server und gewährleisten so absolute Privatsphäre.",
    "Confidence Score" to "Konfidenzwert",
    "Confidence score" to "Konfidenzwert",
    "Confidence: 99.8%" to "Konfidenzwert: 99,8 %",
    "Configure formats and download your threat analysis." to "Konfigurieren Sie Formate und laden Sie Ihre Bedrohungsanalyse herunter.",
    "Congratulations! You beat the bot!" to "Herzlichen Glückwunsch! Du hast den Bot besiegt!",
    "Continue Anyway" to "Trotzdem fortfahren",
    "Copy" to "Kopieren",
    "Copy Link" to "Link kopieren",
    "Copy trusted URLs to clipboard." to "Vertrauenswürdige URLs in die Zwischenablage kopieren.",
    "Core v2.4.1 • Build 2025.12.29" to "Core v2.4.1 • Build 2025.12.29",
    "Correct Decision!" to "Richtig Entscheidung!",
    "Correct!" to "Richtig!",
    "Could not save theme preference:" to "Themeneinstellung konnte nicht gespeichert werden:",
    "Couldn\\'t Read QR Code" to "QR-Code konnte nicht gelesen werden",
    "Credential Harvesting Path" to "Credential Harvesting Path",
    "Credential Harvesting Path (/login)" to "Credential Harvesting Path (/login)",
    "Current" to "Aktuell",
    "Cyrillic characters mimicking Latin alphabet detected." to "Kyrillische Zeichen, die das lateinische Alphabet imitieren erkannt.",
    "DB CHECK" to "DB CHECK",
    "DISCONNECTED" to "DISCONNECTED",
    "DO NOT VISIT" to "NICHT BESUCHEN",
    "DOMAIN" to "DOMAIN",
    "Dangerous" to "Gefährlich",
    "Dark" to "Dunkel",
    "Dashboard" to "Dashboard",
    "Data Lifecycle Verification" to "Verifizierung des Datenlebenszyklus",
    "Data Point" to "Daten Punkt",
    "Data exported successfully!" to "Daten erfolgreich exportiert!",
    "Data sent without encryption can be intercepted" to "Unverschlüsselt gesendete Daten können abgefangen werden",
    "Database Updated" to "Datenbank aktualisiert",
    "Decoded URL/Payload" to "Dekodierte URL/Payload",
    "Deep subdomains can hide the actual domain at the end" to "Tiefe Subdomains können die tatsächliche Domain am Ende verbergen",
    "Destination URL obfuscated. Unable to verify final target." to "Ziel-URL verschleiert. Das endgültige Ziel konnte nicht verifiziert werden.",
    "Details" to "Details",
    "Detection" to "Erkennung",
    "Deutsch" to "Deutsch",
    "Disable all external link previews." to "Alle Vorschauen externer Links deaktivieren.",
    "Display" to "Anzeige",
    "Display threat probability percentage" to "Prozentsatz der Bedrohungswahrscheinlichkeit anzeigen",
    "Do Not Visit This URL" to "Diese URL nicht besuchen",
    "Domain \"apple-id-verify.com\" is not owned by Apple" to "Domain „apple-id-verify.com“ gehört nicht von Apple",
    "Domain age > 5 years (High trust)." to "Domain-Alter > 5 Jahre (hohes Vertrauen).",
    "Domain age is less than 24 hours." to "Domain-Alter ist weniger als 24 Stunden.",
    "Domain already in list" to "Domain bereits in der Liste",
    "Domain contains \"xn--\" IDN encoding" to "Domain enthält „xn--“ IDN-Kodierung",
    "Domain contains or mimics a known brand name (PayPal, Amazon, etc.)" to "Domain enthält oder imitiert einen bekannten Markennamen (PayPal, Amazon, usw.)",
    "Domain mimics known brand (PayPal → Paypa1). High-confidence phishing." to "Domain imitiert bekannte Marke (PayPal → Paypa1). Hochvertrauliches Phishing.",
    "Domain mimics legitimate bank (commbank.com.au)" to "Domain imitiert legitime Bank (commbank.com.au)",
    "Domain or path contains random-looking character sequences" to "Domain oder Pfad enthält zufällig aussehende Zeichenfolgen",
    "Domain registered > 5 years ago. Low probability of churn-and-burn." to "Domain vor > 5 Jahren registriert. Geringe Wahrscheinlichkeit von Churn-and-Burn.",
    "Domain registered in the last 24 hours" to "Domain in den letzten 24 Stunden registriert",
    "Domain uses common misspellings or character substitutions (paypa1, amaz0n)" to "Domain verwendet häufige Rechtschreibfehler oder Zeichenersetzungen (paypa1, amaz0n)",
    "Domain uses suspicious hyphenated structure (verify-deliveries.net)" to "Domain verwendet verdächtige Bindestrichstruktur (verify-deliveries.net)",
    "Don't just get a \"Block\". We provide detailed heuristic breakdowns of URL parameters, redirects, and javascript payloads." to "Erhalten Sie nicht einfach eine „Blockierung“. Wir bieten detaillierte heuristische Aufschlüsselungen von URL-Parametern, Weiterleitungen und Javascript-Nutzlasten.",
    "Download Apps" to "Apps herunterladen",
    "Drag & Drop QR code image here" to "Ziehen Sie ein QR-Code-Bild hier per Drag & Drop",
    "Drag & drop a QR code image here or enable camera access to start scanning." to "Ziehen Sie ein QR-Code-Bild hier per Drag & Drop oder aktivieren Sie den Kamerazugriff, um mit dem Scannen zu beginnen.",
    "Educational Note" to "Schulungshinweis",
    "Embedded Redirect" to "Eingebettete Weiterleitung",
    "Enable Camera" to "Aktivieren Kamera",
    "Enable camera first" to "Kamera zuerst aktivieren",
    "End Session" to "Sitzung beenden",
    "Engine" to "Engine",
    "Engine Active" to "Engine aktiv",
    "Engine Active (Offline)" to "Engine aktiv (Offline)",
    "Engine initializing, please wait..." to "Engine wird initialisiert, bitte warten...",
    "Engine initializing..." to "Engine wird initialisiert...",
    "Engine not ready, using demo mode" to "Engine nicht bereit, Demo wird verwendet Modus",
    "English" to "Englisch",
    "Enter" to "Eingabe",
    "Enter URL" to "URL eingeben",
    "Enter URL Manually" to "URL manuell eingeben",
    "Enterprise Plan" to "Enterprise-Plan",
    "Enterprise Protection Active" to "Enterprise-Schutz Aktiv",
    "Esc" to "Esc",
    "Escape" to "Escape",
    "Español" to "Español",
    "Established Domain" to "Etablierte Domain",
    "Excessive Subdomains" to "Überzählige Subdomains",
    "Excessively Long URL" to "Überlange URL",
    "Exit" to "Beenden",
    "Explainable Defence." to "Erklärbar Verteidigung.",
    "Explainable Security" to "Erklärbare Sicherheit",
    "Export" to "Export",
    "Export Report" to "Bericht exportieren",
    "Export Reports" to "Berichte exportieren",
    "Exports include all identified threat vectors, headers, and the raw payload analysis." to "Die Exporte umfassen alle identifizierten Bedrohungsvektoren, Header und die Rohnutzlastanalyse.",
    "External Transmission" to "Externe Übertragung",
    "FAIL" to "FEHLER",
    "Failed to copy link" to "Kopieren fehlgeschlagen Link",
    "Failed to copy report" to "Fehler beim Kopieren des Berichts",
    "Failed to get scan statistics:" to "Scan-Statistiken konnten nicht abgerufen werden:",
    "Failed to load image" to "Bild konnte nicht geladen werden",
    "Failed to read file" to "Datei konnte nicht gelesen werden",
    "Failed to share" to "Freigabe fehlgeschlagen",
    "Failed to share report" to "Bericht konnte nicht geteilt werden",
    "File upload (image scanning unavailable)" to "Datei-Upload (Scannen von Bildern). nicht verfügbar)",
    "Final Destination" to "Endgültiges Ziel",
    "Final Results" to "Endgültige Ergebnisse",
    "Fix it" to "Reparieren",
    "For the best experience, use Chrome, Firefox, Safari, or Edge." to "Für die beste Erfahrung verwenden Sie Chrome, Firefox, Safari oder Edge.",
    "Found in 3 local offline threat databases." to "Gefunden in 3 lokalen Offline-Bedrohungsdatenbanken.",
    "Français" to "Français",
    "Free/cheap TLDs are heavily abused for throwaway phishing domains" to "Kostenlose/günstige TLDs werden stark missbraucht Wegwerf-Phishing-Domains",
    "Gallery" to "Galerie",
    "Game Over!" to "Game Over!",
    "Generate Test QR" to "Test-QR generieren",
    "Generate a test malicious QR code" to "Bösartigen Test-QR-Code generieren",
    "Generated on Dec 29, 2025 • 14:32:01 UTC" to "Generiert am 29. Dez. 2025 • 14:32:01 UTC",
    "Generated on {date} • {time} UTC" to "Generiert am {date} • {time} UTC",
    "Generating {format} report..." to "Erstellen eines {format}-Berichts...",
    "Get Started! 🚀" to "Erstellen Sie jetzt! 🚀",
    "GitHub" to "GitHub",
    "GitHub.com is a legitimate developer platform owned by Microsoft. Always verify the exact domain spelling." to "GitHub.com ist eine legitime Entwicklerplattform im Besitz von Microsoft. Überprüfen Sie immer die genaue Schreibweise der Domain.",
    "Gmail" to "Gmail",
    "Google Docs" to "Google Docs",
    "Google Docs uses docs.google.com. Always verify the sender knows you before opening shared documents." to "Google Docs verwendet docs.google.com. Stellen Sie immer sicher, dass der Absender Sie kennt, bevor Sie freigegebene Dokumente öffnen.",
    "Google services use subdomains of google.com. mail.google.com is the legitimate Gmail address." to "Google-Dienste verwenden Subdomains von google.com. mail.google.com ist die legitime Gmail-Adresse.",
    "Got it" to "Verstanden",
    "HIGH" to "HIGH",
    "HIGH RISK" to "HOHES RISIKO",
    "HIGH RISK DETECTED" to "HOHES RISIKO ERKENNT",
    "HTTP instead of HTTPS (no encryption)" to "HTTP statt HTTPS (Nr Verschlüsselung)",
    "HTTPS" to "HTTPS",
    "Help" to "Hilfe",
    "Heuristic Engine" to "Heuristische Engine",
    "Heuristics" to "Heuristik",
    "Hides the true destination URL from the user" to "Versteckt die wahre Ziel-URL vor dem Benutzer",
    "High" to "Hoch",
    "High Entropy" to "Hohe Entropie",
    "High Risk" to "Hohes Risiko",
    "High entropy string detected in URL parameters." to "String mit hoher Entropie in URL-Parametern erkannt.",
    "High-Performance Engine" to "High-Performance Engine",
    "High-Risk TLD" to "High-Risk-TLD",
    "High-Risk URL Blocked" to "High-Risk-URL blockiert",
    "High-confidence phishing detected. This URL exhibits multiple malicious indicators." to "High-Confidenz-Phishing erkannt. Diese URL weist mehrere schädliche Indikatoren auf.",
    "Hold steady. Analysed offline in <5ms." to "Halten Sie es ruhig. Offline analysiert in <5 ms.",
    "Home" to "Home",
    "Homograph / IDN Attack" to "Homograph / IDN-Angriff",
    "Homograph Attack" to "Homograph-Angriff",
    "Homograph attack: \"c0mmonwealth\" uses zero instead of letter O" to "Homograph-Angriff: „c0mmonwealth“ verwendet Null anstelle des Buchstabens O",
    "Homograph attack: \"paypa1\" uses number 1 instead of letter L" to "Homograph-Angriff: „paypa1“ verwendet Nummer 1 anstelle des Buchstabens L",
    "Homograph attacks use similar-looking characters. Always check URLs character by character for suspicious substitutions." to "Homograph Angriffe verwenden ähnlich aussehende Charaktere. Überprüfen Sie URLs immer Zeichen für Zeichen auf verdächtige Ersetzungen.",
    "How aggressive should threat detection be?" to "Wie aggressiv sollte die Bedrohungserkennung sein?",
    "Human-Readable Report" to "Menschenlesbarer Bericht",
    "I am reporting a suspected phishing URL detected by Mehr Guard:" to "Ich melde eine mutmaßliche Phishing-URL, die von Mehr Guard entdeckt wurde:",
    "ID: scan_2023_10_24_af92" to "ID: scan_2023_10_24_af92",
    "ID: {id}" to "ID: {id}",
    "INFO" to "INFO",
    "IP Address Host" to "IP-Adress-Host",
    "If HTTPS was used, this signal would not trigger and score would drop by ~18 points." to "Wenn HTTPS verwendet würde, würde dieses Signal nicht ausgelöst und die Punktzahl würde um ~18 Punkte sinken.",
    "If a registered domain name was used instead of IP address, score would drop by ~28 points." to "Wenn ein registrierter Domainname anstelle der IP-Adresse verwendet würde, würde die Punktzahl um ~28 Punkte sinken.",
    "If all characters were ASCII Latin letters, this signal would not trigger and score would drop by ~45 points." to "Wenn alle Zeichen lateinische ASCII-Buchstaben wären, würde dieses Signal nicht ausgelöst und die Punktzahl würde sinken ~45 Punkte.",
    "If no embedded URLs were present in query parameters, score would drop by ~18 points." to "Wenn in den Abfrageparametern keine eingebetteten URLs vorhanden wären, würde die Punktzahl um ~18 Punkte sinken.",
    "If only 1-2 subdomains were used, this signal would not trigger. Score would drop by ~12 points." to "Wenn nur 1-2 Subdomains verwendet würden, würde dieses Signal nicht ausgelöst. Die Punktzahl würde um ~12 Punkte sinken.",
    "If the domain spelled the brand correctly without substitutions, score would drop by ~25 points." to "Wenn die Domain die Marke ohne Ersetzungen korrekt buchstabieren würde, würde die Punktzahl um ~25 Punkte sinken.",
    "If the domain used only ASCII characters (no IDN), score would drop by ~32 points." to "Wenn die Domain nur ASCII-Zeichen (keine IDN) verwenden würde, würde die Punktzahl um ~32 Punkte sinken.",
    "If the domain used readable words instead of random characters, score would drop by ~12 points." to "Wenn die Domain lesbare Wörter anstelle von Zufallszeichen verwenden würde, würde die Punktzahl um ~12 Punkte sinken.",
    "If the full destination URL was visible, score would drop by ~18 points (assuming destination is safe)." to "Wenn die vollständige Ziel-URL verwendet würde Wenn diese URL sichtbar ist, würde die Punktzahl um etwa 18 Punkte sinken (vorausgesetzt, das Ziel ist sicher).",
    "If this URL used .com, .org, or country TLDs, score would drop by ~25 points." to "Wenn diese URL .com, .org oder Länder-TLDs verwendet, würde die Punktzahl um etwa 25 Punkte sinken.",
    "If this were the official brand domain (paypal.com), this signal would not trigger and score would drop by ~35 points." to "Wäre dies die offizielle Markendomain (paypal.com), würde dieses Signal nicht ausgelöst und die Punktzahl würde um ~35 Punkte sinken.",
    "Import Image" to "Bild importieren",
    "Imported: {name}" to "Importiert: {name}",
    "Incoming Message (+61 491 570 010):" to "Eingehende Nachricht (+61 491 570 010):",
    "Incorrect Decision" to "Falsche Entscheidung",
    "Intermediate Hop" to "Mittel Hop",
    "International domains can hide malicious lookalike characters" to "Internationale Domains können bösartige ähnliche Zeichen verbergen",
    "Invalid URL Format" to "Ungültiges URL-Format",
    "Invalid URL format" to "Ungültiges URL-Format",
    "Invalid theme:" to "Ungültiges Thema:",
    "Isolated Sandbox" to "Isolierte Sandbox",
    "It's a Tie!" to "It's a Tie!",
    "JS" to "JS",
    "JSON format. Best for SIEM integration." to "JSON-Format. Am besten für SIEM-Integration geeignet.",
    "JSON report downloaded" to "JSON-Bericht heruntergeladen",
    "John Smith" to "John Smith",
    "Judge Mode" to "Beurteilungsmodus",
    "Judge Mode Active" to "Beurteilungsmodus aktiv",
    "Judge Mode OFF - Normal detection active" to "Beurteilungsmodus AUS – Normale Erkennung aktiv",
    "Judge Mode: Force MALICIOUS results for demo" to "Beurteilungsmodus: SCHÄDLICHE Ergebnisse für Demo erzwingen",
    "Judge Mode: ON" to "Beurteilungsmodus: ON",
    "Just now" to "Gerade jetzt",
    "Kotlin Multiplatform" to "Kotlin Multiplattform",
    "Kotlin engine not ready yet" to "Kotlin-Engine noch nicht fertig",
    "Kotlin/Wasm" to "Kotlin/Wasm",
    "KotlinConf Student Competition 2025-2026" to "KotlinConf Student Competition 2025-2026",
    "LIVE" to "LIVE",
    "LIVE FEED ACTIVE" to "LIVE FEED AKTIV",
    "LIVE FEED DISCONNECTED" to "LIVE FEED GETRENNT",
    "LOW" to "NIEDRIG",
    "LOW RISK" to "NIEDRIGES RISIKO",
    "Language: {language} {flag}" to "Sprache: {language} {flag}",
    "Last Update" to "Letzte Aktualisierung",
    "Latency" to "Latenzzeit",
    "Latency: 2ms" to "Latenzzeit: 2 ms",
    "Learn about our local architecture" to "Erfahren Sie mehr über unsere lokale Architektur",
    "Learn how to identify advanced QR homograph attacks." to "Erfahren Sie, wie Sie fortgeschrittene QR-Homograph-Angriffe erkennen.",
    "Legitimate" to "Legitim",
    "Legitimate services use domains; IPs hide identity and bypass filters" to "Legitime Dienste nutzen Domänen; IPs verbergen Identität und umgehen Filter",
    "Let's Encrypt (R3)" to "Let's Encrypt (R3)",
    "Light" to "Light",
    "Limited Browser Support" to "Eingeschränkte Browserunterstützung",
    "Link copied to clipboard!" to "Link in Zwischenablage kopiert!",
    "LinkedIn" to "LinkedIn",
    "LinkedIn uses linkedin.com as their primary domain. Profile URLs follow the /in/username format." to "LinkedIn verwendet LinkedIn.com als primäre Domain. Profil-URLs folgen dem Format /in/Benutzername.",
    "Live Hint" to "Live-Hinweis",
    "Live Preview" to "Live-Vorschau",
    "Live Scanner" to "Live-Scanner",
    "Live Scoreboard" to "Live-Scoreboard",
    "Local DB" to "Lokale Datenbank",
    "Local Database" to "Lokale Datenbank",
    "Local Memory (RAM)" to "Lokaler Speicher (RAM)",
    "Local Privacy" to "Lokal Datenschutz",
    "Local Sandbox" to "Lokale Sandbox",
    "Local database v2.4.1 active. No data leaves this device." to "Lokale Datenbank v2.4.1 aktiv. Keine Daten verlassen dieses Gerät.",
    "Local storage (history won\\'t persist)" to "Lokaler Speicher (Verlauf bleibt nicht erhalten)",
    "Long URLs can hide malicious parameters or overwhelm users" to "Lange URLs können schädliche Parameter verbergen oder Benutzer überfordern",
    "Look at the domain carefully. Is \"c0mmonwealth\" spelled correctly? The number 0 is often used to replace the letter O." to "Sehen Sie sich die Domain genau an. Ist „c0mmonwealth“ richtig geschrieben? Die Zahl 0 wird oft verwendet, um den Buchstaben O zu ersetzen.",
    "Look at the domain name carefully. Is \"paypa1\" spelled correctly?" to "Sehen Sie sich den Domainnamen genau an. Ist „paypa1“ richtig geschrieben?",
    "Look closely at the domain structure. Legitimate organisations rarely use hyphens in the main domain name or generic TLDs like" to "Schauen Sie sich die Domainstruktur genau an. Seriöse Organisationen verwenden selten Bindestriche im Hauptdomänennamen oder generischen TLDs wie",
    "Low" to "Niedrig",
    "Low Risk" to "Niedriges Risiko",
    "Low Sensitivity Mode" to "Niedriger Empfindlichkeitsmodus",
    "MALICIOUS" to "BÖSLICH",
    "MEDIUM" to "MITTEL",
    "MEDIUM RISK" to "MITTLERES RISIKO",
    "MINOR CONCERNS" to "MINOR BEDENKEN",
    "Machine-Readable" to "Maschinenlesbar",
    "Make your decision" to "Treffen Sie Ihre Entscheidung",
    "Malicious" to "Bösartig",
    "Manage privacy controls, sensitivity, and security lists." to "Verwalten Sie Datenschutzkontrollen, Vertraulichkeit und Sicherheitslisten.",
    "Matched 3 signatures in local phishing DB." to "Übereinstimmung mit 3 Signaturen in der lokalen Phishing-Datenbank.",
    "Maximum protection. Blocks any suspicious patterns including newly registered domains, uncommon TLDs, and any URL with potential encoding tricks." to "Maximaler Schutz. Blockiert alle verdächtigen Muster, einschließlich neu registrierter Domains, ungewöhnlicher TLDs und aller URLs mit potenziellen Codierungstricks.",
    "Medium" to "Mittel",
    "Microsoft-owned platform" to "Microsoft-eigene Plattform",
    "Missing features:" to "Fehlende Funktionen:",
    "More than 3 subdomain levels (secure.login.paypal.fake.com)" to "Mehr als 3 Subdomain-Ebenen (secure.login.paypal.fake.com)",
    "Need help? Visit our GitHub for documentation" to "Benötigen Sie Hilfe? Besuchen Sie unseren GitHub für Dokumentation",
    "Never trust shortened URLs from unknown sources. Use URL expander tools to see the real destination before clicking." to "Vertrauen Sie niemals verkürzten URLs aus unbekannten Quellen. Verwenden Sie URL-Expander-Tools, um das tatsächliche Ziel anzuzeigen, bevor Sie darauf klicken.",
    "Newly Registered Domain" to "Neu registrierte Domain",
    "Next Round" to "Nächste Runde",
    "Next →" to "Weiter →",
    "No Cloud Logs" to "Keine Cloud-Protokolle",
    "No HTTPS Encryption" to "Keine HTTPS-Verschlüsselung",
    "No HTTPS encryption" to "Keine HTTPS-Verschlüsselung",
    "No QR code found in image" to "Kein QR-Code gefunden in Bild",
    "No URL to copy" to "Keine URL zum Kopieren",
    "No URL to open" to "Keine URL zum Öffnen",
    "No URL to report - analyze one first" to "Keine URL zum Melden – analysieren Sie zuerst eine",
    "No camera found" to "Keine Kamera gefunden",
    "No custom domains blocked." to "Keine benutzerdefinierten Domains blockiert.",
    "No data leaves device" to "Keine Daten verlassen das Gerät",
    "No new notifications" to "Keine neuen Benachrichtigungen",
    "No recent analysis to view" to "Keine aktuelle Analyse zu anzeigen",
    "No recent scans" to "Keine aktuellen Scans",
    "No security threats were detected. The QR code leads to a verified safe destination." to "Es wurden keine Sicherheitsbedrohungen erkannt. Der QR-Code führt zu einem verifizierten sicheren Ziel.",
    "No threats detected" to "Keine Bedrohungen erkannt",
    "None" to "Keine",
    "Not a valid URL" to "Keine gültige URL",
    "Not found in 52 local offline threat databases." to "Nicht in 52 lokalen Offline-Bedrohungsdatenbanken gefunden.",
    "Not the official PayPal domain (paypal.com)" to "Nicht die offizielle PayPal-Domäne (paypal.com)",
    "Notifications" to "Benachrichtigungen",
    "Obfuscated JavaScript" to "Verschleiert JavaScript",
    "Obfuscated Script" to "Verschleiertes Skript",
    "Official LinkedIn domain" to "Offizielle LinkedIn-Domain",
    "Official postal services use their primary domain (auspost.com.au) for all tracking. Verify by visiting the official website directly." to "Offizielle Postdienste verwenden ihre primäre Domain (auspost.com.au) für die gesamte Nachverfolgung. Überprüfen Sie dies, indem Sie direkt die offizielle Website besuchen.",
    "Offline" to "Offline",
    "Offline Core v2.4" to "Offline Core v2.4",
    "Offline Engine V.2.4" to "Offline Engine V.2.4",
    "Offline Guarantee:" to "Offline-Garantie:",
    "Offline Mode" to "Offline-Modus",
    "Offline Mode Active" to "Offline-Modus aktiv",
    "Offline Privacy" to "Offline-Datenschutz",
    "Offline Protection" to "Offline-Schutz",
    "Offline Ready" to "Offline-fähig",
    "Offline Security" to "Offline-Sicherheit",
    "Offline-First Architecture" to "Offline-First-Architektur",
    "On-Device DB" to "Datenbank auf dem Gerät",
    "On-Device Database" to "Datenbank auf dem Gerät",
    "Onboarding" to "Onboarding",
    "Only blocks known malicious URLs from the threat database. Minimal false positives, but may miss novel attacks." to "Blockiert nur bekannte schädliche URLs aus der Bedrohungsdatenbank. Minimale Fehlalarme, aber möglicherweise übersehen neuartige Angriffe.",
    "Open Safely (Sandbox)" to "Sicher öffnen (Sandbox)",
    "Open Source Licenses" to "Open-Source-Lizenzen",
    "Opening PhishTank..." to "PhishTank öffnen...",
    "Opening URL in new tab" to "URL in neuem Tab öffnen",
    "Opening email client..." to "E-Mail-Client öffnen...",
    "Optimised for desktop environments. Scans are processed in under 5ms using native Kotlin Multiplatform binaries." to "Optimiert für Desktop-Umgebungen. Scans werden in weniger als 5 ms mit nativen Kotlin-Multiplattform-Binärdateien verarbeitet.",
    "Overview" to "Übersicht",
    "PASS" to "PASS",
    "PDF format. Best for sharing with stakeholders." to "PDF-Format. Am besten zum Teilen mit Stakeholdern geeignet.",
    "PDF report ready for download" to "PDF-Bericht steht zum Download bereit",
    "PHISH" to "PHISH",
    "PHISHING" to "PHISHING",
    "PROCEED WITH CAUTION" to "VORSICHT VORGEHEN",
    "Paranoia" to "Paranoia",
    "Paranoia Mode" to "Paranoia-Modus",
    "Paste URL" to "URL einfügen",
    "Paste URL to Analyze" to "URL einfügen in Analysieren",
    "PayPal Security" to "PayPal-Sicherheit",
    "Permissive" to "Zulässig",
    "Phishing" to "Phishing",
    "Phishing Attempt" to "Phishing-Versuch",
    "Phishing Detection Sensitivity" to "Phishing-Erkennungsempfindlichkeit",
    "Phishing Engine" to "Phishing-Engine",
    "Phishing Report: {url}" to "Phishing-Bericht: {url}",
    "Phishing detection is running normally" to "Phishing Erkennung läuft normal",
    "Play Again" to "Erneut abspielen",
    "Play Now" to "Jetzt abspielen",
    "Play sound when threat detected" to "Ton abspielen, wenn Bedrohung erkannt wird",
    "Please drop an image file" to "Bitte legen Sie eine Bilddatei ab",
    "Please enter a URL" to "Bitte geben Sie eine URL ein",
    "Please enter a domain" to "Bitte geben Sie eine Domain ein",
    "Please enter a valid domain" to "Bitte geben Sie eine gültige Domain ein",
    "Please select an image" to "Bitte wählen Sie ein Bild aus",
    "Point your camera at a QR code to detect" to "Zeigen Sie Kamera an einem zu erkennenden QR-Code",
    "Points" to "Punkte",
    "Press Cmd/Ctrl+V again to paste" to "Drücken Sie zum Einfügen erneut Cmd/Strg+V",
    "Privacy Controls" to "Datenschutzkontrollen",
    "Privacy Policy" to "Datenschutzrichtlinie",
    "Privacy Settings" to "Datenschutzeinstellungen",
    "Privacy policy: 100% offline, zero data collection" to "Datenschutzrichtlinie: 100 % offline, keine Datenerfassung",
    "Proceed with Caution" to "Weiter mit Achtung",
    "Processing Env" to "Env wird verarbeitet",
    "Processing image..." to "Bild wird verarbeitet...",
    "Profile" to "Profil",
    "Profile updated successfully!" to "Profil erfolgreich aktualisiert!",
    "Punycode Domain" to "Punycode-Domäne",
    "QR Code Detected!" to "QR-Code erkannt!",
    "QR Code Scan" to "QR-Code-Scan",
    "QR Code detected!" to "QR-Code erkannt!",
    "Mehr Guard" to "Mehr Guard",
    "Mehr Guard - Beat the Bot" to "Mehr Guard – Beat the Bot",
    "Mehr Guard - Dashboard" to "Mehr Guard – Dashboard",
    "Mehr Guard - Offline Privacy Onboarding" to "Mehr Guard – Offline-Datenschutz-Onboarding",
    "Mehr Guard - Scan Dashboard" to "Mehr Guard – Scan-Dashboard",
    "Mehr Guard - Scan Result" to "Mehr Guard – Scan Ergebnis",
    "Mehr Guard - Trust Centre" to "Mehr Guard - Trust Center",
    "Mehr Guard Logo" to "Mehr Guard Logo",
    "Mehr Guard Results" to "Mehr Guard Ergebnisse",
    "Mehr Guard Scan Result" to "Mehr Guard Scan-Ergebnis",
    "Mehr Guard Security Audit" to "Mehr Guard Sicherheitsaudit",
    "Mehr Guard Threat Analysis Report" to "Mehr Guard Bedrohungsanalyse Bericht",
    "Mehr Guard Threat Report" to "Mehr Guard Bedrohungsbericht",
    "Mehr Guard Verdict: {verdict}" to "Mehr Guard Urteil: {verdict}",
    "Mehr Guard analyses potential threats directly on your hardware. Experience" to "Mehr Guard analysiert potenzielle Bedrohungen direkt auf Ihrer Hardware. Erfahrung",
    "Mehr Guard explains" to "Mehr Guard erklärt",
    "Mehr Guard needs camera access to scan QR codes in real-time." to "Mehr Guard benötigt Kamerazugriff, um QR-Codes in Echtzeit zu scannen.",
    "Mehr Guard processes every scan within a secure, isolated local sandbox. We prioritize explainable security with zero cloud telemetry for image analysis." to "Mehr Guard verarbeitet jeden Scan in einer sicheren, isolierten lokalen Sandbox. Wir priorisieren erklärbare Sicherheit mit Zero-Cloud-Telemetrie für die Bildanalyse.",
    "Mehr Guard strictly disables all outgoing telemetry. Your scan results, URL history, and image hashes never leave your device." to "Mehr Guard deaktiviert strikt alle ausgehenden Telemetriedaten. Ihre Scan-Ergebnisse, URL-Verlauf und Bild-Hashes verlassen niemals Ihr Gerät.",
    "Mehr Guard uses local heuristic analysis engines. No image data, URL strings, or metadata leaves this device during scanning. Your privacy is mathematically guaranteed." to "Mehr Guard verwendet lokale heuristische Analyse-Engines. Während des Scanvorgangs verlassen keine Bilddaten, URL-Strings oder Metadaten dieses Gerät. Ihre Privatsphäre ist mathematisch garantiert.",
    "Mehr Guard works 100% offline! All analysis is done locally on your device. No internet connection required." to "Mehr Guard funktioniert 100 % offline! Die gesamte Analyse erfolgt lokal auf Ihrem Gerät. Keine Internetverbindung erforderlich.",
    "Mehr Guard | Premium Web Scanner" to "Mehr Guard | Premium Web Scanner",
    "Mehr Guard Bot" to "Mehr Guard Bot",
    "Quarantine in Sandbox" to "Quarantäne in Sandbox",
    "Quarantined in secure sandbox for analysis" to "In sicherer Sandbox zur Analyse isoliert",
    "READY" to "BEREIT",
    "Randomly generated domains are often temporary phishing sites" to "Zufällig generierte Domains sind oft temporäre Phishing-Sites",
    "Raw Image Buffer" to "Raw Image Buffer",
    "Read Only" to "Lesen Nur",
    "Real-Time Scanning" to "Echtzeit-Scanning",
    "Real-time scanning" to "Echtzeit-Scanning",
    "Recent Scans" to "Letzte Scans",
    "Recommended Actions" to "Empfohlene Aktionen",
    "Refresh Page" to "Seite aktualisieren",
    "Removed {domain} from {list}" to "{domain} aus {list} entfernt",
    "Removing or changing the suspicious pattern would reduce the overall risk score." to "Das Entfernen oder Ändern des verdächtigen Musters würde die reduzieren Gesamtrisikobewertung.",
    "Report Export - Mehr Guard" to "Berichtsexport – [[MARKE]]",
    "Report Generation" to "Berichterstellung",
    "Report Incorrect Verdict" to "Falsches Urteil melden",
    "Report Phishing" to "Phishing melden",
    "Report URL copied to clipboard" to "URL in die Zwischenablage kopiert melden",
    "Report copied to clipboard" to "Bericht in die Zwischenablage kopiert",
    "Report if this verdict is wrong" to "Melden Sie, ob dieses Urteil zutrifft falsch",
    "Report shared" to "Freigabe melden",
    "Report shared successfully!" to "Freigabe erfolgreich gemeldet!",
    "Reported: {timestamp}" to "Gemeldet: {timestamp}",
    "Reports" to "Berichte",
    "Reset Defaults" to "Standardeinstellungen zurücksetzen",
    "Reset all Trust Centre settings to default?" to "Alle Trust Center-Einstellungen auf Standard zurücksetzen?",
    "Reset all settings to default" to "Alle Einstellungen zurücksetzen auf Standard",
    "Response" to "Antwort",
    "Result" to "Ergebnis",
    "Result # {id}" to "Ergebnis # {id}",
    "Result #8291-A" to "Ergebnis #8291-A",
    "Result copied to clipboard!" to "Ergebnis in Zwischenablage kopiert!",
    "Results Dashboard" to "Ergebnis-Dashboard",
    "Return to Dashboard" to "Zurück zum Dashboard",
    "Risk Assessment" to "Risiko Bewertung",
    "Risk Score" to "Risikobewertung",
    "Risk Score: {score}/100" to "Risikobewertung: {score}/100",
    "Risk impact:" to "Risikoauswirkung:",
    "Round" to "Runde",
    "SAFE" to "SICHER",
    "SAFE TO VISIT" to "SICHER ZU BESUCHEN",
    "SMS from unknown number impersonating AusPost" to "SMS von einer unbekannten Nummer, die sich als AusPost ausgibt",
    "SSL Certificate Issues" to "SSL-Zertifikatsprobleme",
    "SUSPICIOUS" to "VERDÄCHTIG",
    "SUSPICIOUS ACTIVITY" to "VERDÄCHTIGE AKTIVITÄT",
    "Safe" to "Sicher",
    "Safe Scans" to "Sichere Scans",
    "Safe to Visit" to "Sicher zu Besuchen",
    "Safe vs Risky QR Codes" to "Sichere vs. riskante QR-Codes",
    "Safety Score" to "Sicherheitsbewertung",
    "Save & Continue" to "Speichern und fortfahren",
    "Scan" to "Scannen",
    "Scan # {id}" to "Scannen # {id}",
    "Scan #8021-AF" to "Scannen #8021-AF",
    "Scan Another" to "Anderen scannen",
    "Scan Complete" to "Scannen abgeschlossen",
    "Scan History" to "Scannen Verlauf",
    "Scan Meta" to "Scan-Meta",
    "Scan Monitor" to "Scan-Monitor",
    "Scan New QR" to "Neuen QR scannen",
    "Scan QR" to "QR scannen",
    "Scan QR Code" to "QR-Code scannen",
    "Scan QR codes as they're detected" to "QR-Codes scannen, sobald sie erkannt werden",
    "Scan Time" to "Scan-Zeit",
    "Scan URLs Safely" to "URLs sicher scannen",
    "Scan history cleared" to "Scan-Verlauf gelöscht",
    "Scan this QR code with Mehr Guard to see malicious URL detection:" to "Scannen Sie diesen QR-Code mit Mehr Guard, um die Erkennung schädlicher URLs zu sehen:",
    "Scanned with Mehr Guard - {url}" to "Gescannt mit Mehr Guard - {url}",
    "Scanner Dashboard" to "Scanner-Dashboard",
    "Scanning..." to "Scannen...",
    "Scans" to "Scannen",
    "Scans for known malicious patterns and heuristic mismatches. Blocks homoglyph attacks and redirect chains. Low false positive rate expected." to "Scannen nach bekannten schädlichen Mustern und heuristischen Abweichungen. Blockiert Homoglyphenangriffe und Weiterleitungsketten. Niedrige Falsch-Positiv-Rate erwartet.",
    "Secure Environment" to "Sichere Umgebung",
    "Secure. Offline." to "Sicher. Offline.",
    "Security" to "Sicherheit",
    "Security Analyst" to "Sicherheitsanalyst",
    "Security Audit: PASS" to "Sicherheitsaudit: BESTANDEN",
    "Security Engine Active" to "Sicherheits-Engine aktiv",
    "Security Heuristics" to "Sicherheitsheuristiken",
    "Security Settings" to "Sicherheitseinstellungen",
    "Security audit report downloaded" to "Sicherheitsauditbericht heruntergeladen",
    "See Results" to "Ergebnisse anzeigen",
    "See the difference instantly:" to "Sehen Sie den Unterschied sofort:",
    "Sensitivity Level" to "Empfindlichkeitsstufe",
    "Sensitivity set to {level}" to "Empfindlichkeit eingestellt auf {level}",
    "Session ID: #GAME-" to "Sitzungs-ID: #GAME-",
    "Settings" to "Einstellungen",
    "Settings are saved automatically and sync across sessions." to "Einstellungen werden automatisch gespeichert und synchronisiert Sitzungen.",
    "Settings reset to default" to "Einstellungen auf Standard zurückgesetzt",
    "Settings reset to defaults" to "Einstellungen auf Standard zurückgesetzt",
    "Settings saved! Your data stays on-device." to "Einstellungen gespeichert! Ihre Daten bleiben auf dem Gerät.",
    "Share" to "Teilen",
    "Share Report" to "Bericht teilen",
    "Share detection stats to improve ML." to "Erkennungsstatistiken teilen, um ML zu verbessern.",
    "Shared successfully!" to "Erfolgreich geteilt!",
    "Sharing not supported" to "Teilen nicht unterstützt",
    "Short URLs hide the actual destination. Prize claims from unknown numbers are almost always scams." to "Kurze URLs verbergen das eigentliche Ziel. Gewinnansprüche von unbekannten Nummern sind fast immer Betrug.",
    "Shortened URL hides true destination" to "Verkürzte URL verbirgt wahres Ziel",
    "Show Confidence Score" to "Konfidenzwert anzeigen",
    "Show visual alerts for threats" to "Visuelle Warnungen für Bedrohungen anzeigen",
    "Sign in to your GitHub account to access your repositories." to "Melden Sie sich bei Ihrem GitHub-Konto an, um auf Ihre Repositorys zuzugreifen.",
    "Signatures" to "Signaturen",
    "Skip" to "Überspringen",
    "Some features may not work in your browser." to "Einige Möglicherweise funktionieren die Funktionen in Ihrem Browser nicht.",
    "Some minor security concerns were identified. The link appears mostly safe but review recommended." to "Es wurden einige geringfügige Sicherheitsbedenken festgestellt. Der Link erscheint größtenteils sicher, eine Überprüfung wird jedoch empfohlen.",
    "Some suspicious indicators detected. Verify the source before entering sensitive information." to "Einige verdächtige Indikatoren erkannt. Überprüfen Sie die Quelle, bevor Sie vertrauliche Informationen eingeben.",
    "Sound Alerts" to "Akustische Warnungen",
    "Sound alerts" to "Akustische Warnungen",
    "Source" to "Quelle",
    "Standard Gmail URL structure" to "Standard-Gmail-URL-Struktur",
    "Standard Google Docs URL format" to "Standard-URL-Format für Google Docs",
    "Standard profile URL structure" to "Standard-Profil-URL Struktur",
    "Status" to "Status",
    "Streak:" to "Streak:",
    "Strict" to "Strikt",
    "Strict Offline Guarantee" to "Strikte Offline-Garantie",
    "Strict Offline Mode" to "Strikter Offline-Modus",
    "Strict Offline Mode disabled" to "Strikter Offline-Modus deaktiviert",
    "Strict Offline Mode enabled" to "Strikter Offline-Modus aktiviert",
    "Subdomain \"signin\" used for deception" to "Subdomain „Anmeldung“ verwendet für Täuschung",
    "Subdomain of google.com" to "Subdomain von google.com",
    "Subdomain of google.com (trusted)" to "Subdomain von google.com (vertrauenswürdig)",
    "Submitted via Mehr Guard" to "Eingereicht über Mehr Guard",
    "Success!" to "Erfolg!",
    "Support" to "Support",
    "Suspicious" to "Verdächtig",
    "Suspicious Redirect Chain" to "Verdächtige Weiterleitung Kette",
    "Suspicious TLD" to "Verdächtige TLD",
    "Suspicious TLD (.tk)" to "Verdächtige TLD (.tk)",
    "Switch Language: English/Deutsch" to "Sprache wechseln: Englisch/Deutsch",
    "Switched to {mode} mode" to "In den {mode}-Modus gewechselt",
    "System Health" to "Systemzustand",
    "System Secure" to "Systemsicher",
    "System Status" to "Systemstatus",
    "Systems Operational" to "Systeme Betriebsbereit",
    "TLD" to "TLD",
    "Target IP is located in a high-risk ASN." to "Ziel-IP befindet sich in einem ASN mit hohem Risiko.",
    "Target URL" to "Ziel-URL",
    "Technical Indicators" to "Technische Indikatoren",
    "Technical Indicators:" to "Technische Indikatoren:",
    "Terms" to "Bedingungen",
    "Test QR Code" to "QR-Code testen",
    "Thank you! Feedback recorded: Should be {verdict}" to "Vielen Dank! Aufgezeichnetes Feedback: Sollte {verdict} sein",
    "The Kotlin/JS analysis engine is still loading or failed to initialize." to "Die Kotlin/JS-Analyse-Engine wird immer noch geladen oder konnte nicht initialisiert werden.",
    "The bot was faster this time. Try again!" to "Der Bot war dieses Mal schneller. Versuchen Sie es erneut!",
    "The destination URL employs" to "Die Ziel-URL verwendet",
    "The domain uses the Cyrillic 'а' (U+0430) instead of Latin 'a' (U+0061)." to "Die Domain verwendet das kyrillische „а“ (U+0430) anstelle des lateinischen „a“ (U+0061).",
    "The domain uses the Cyrillic 'а' (U+0430) instead of Latin 'a' (U+0061). This technique is commonly used to trick users into believing they are visiting a legitimate service." to "Die Domain verwendet das kyrillische „а“ (U+0430) anstelle des lateinischen „a“ (U+0061). Diese Technik wird häufig verwendet, um Benutzern vorzutäuschen, dass sie einen legitimen Dienst besuchen.",
    "The entire threat signature database (100,000+ patterns) is stored locally for millisecond lookups without any network requests." to "Die gesamte Bedrohungssignaturdatenbank (mehr als 100.000 Muster) wird lokal für Millisekunden-Suchvorgänge ohne Netzwerkanfragen gespeichert.",
    "The entire threat signature database is downloaded to your device for millisecond lookups." to "Die gesamte Bedrohungssignaturdatenbank wird für Millisekunden-Suchvorgänge auf Ihr Gerät heruntergeladen.",
    "The image doesn\\'t contain a recognizable QR code, or it may be damaged." to "Das Bild enthält keinen erkennbaren QR-Code, oder es kann einer sein beschädigt.",
    "The input doesn\\'t appear to be a valid URL." to "Die Eingabe scheint keine gültige URL zu sein.",
    "The number 1 and lowercase L look identical in many fonts. Always verify paypal.com directly." to "Die Zahl 1 und der Kleinbuchstabe L sehen in vielen Schriftarten identisch aus. Überprüfen Sie paypal.com immer direkt.",
    "The pattern matches known phishing characteristics" to "Das Muster stimmt mit bekannten Phishing-Merkmalen überein",
    "The scanned QR code contains malicious indicators associated with phishing and credential harvesting. Do not proceed to the target URL." to "Der gescannte QR-Code enthält bösartige Indikatoren, die mit Phishing und dem Sammeln von Anmeldeinformationen in Zusammenhang stehen. Fahren Sie nicht mit der Ziel-URL fort.",
    "The scanned QR code shows suspicious patterns that may indicate potential security risks. Proceed with caution." to "Der gescannte QR-Code weist verdächtige Muster auf, die auf potenzielle Sicherheitsrisiken hinweisen können. Gehen Sie vorsichtig vor.",
    "Think you can outsmart our AI? Try to craft a phishing URL that fools the detector!" to "Denken Sie, Sie können unsere KI überlisten? Versuchen Sie, eine Phishing-URL zu erstellen, die den Detektor täuscht!",
    "This URL passed all {count} security checks" to "Diese URL hat alle {count} Sicherheitsüberprüfungen bestanden",
    "This URL triggered a security check" to "Diese URL hat eine Sicherheitsüberprüfung ausgelöst",
    "This URL was flagged by Mehr Guard\\'s offline phishing detection engine." to "Diese URL wurde von der Offline-Phishing-Erkennungs-Engine von Mehr Guard markiert.",
    "This image was analysed locally on your device. No data was sent to the cloud for this verdict." to "Dieses Bild wurde lokal auf Ihrem Gerät analysiert. Für dieses Urteil wurden keine Daten an die Cloud gesendet.",
    "This is a Google subdomain - check if it\\'s the legitimate Gmail service." to "Dies ist eine Google-Subdomain – prüfen Sie, ob es sich um den legitimen Gmail-Dienst handelt.",
    "This is a security feature — your URLs never leave your device." to "Dies ist eine Sicherheitsfunktion – Ihre URLs verlassen niemals Ihr Gerät.",
    "This is a well-established software company domain." to "Dies ist eine etablierte Domain eines Softwareunternehmens.",
    "This is the official LinkedIn domain for professional networking." to "Dies ist die offizielle LinkedIn-Domain für professionelles Networking.",
    "This may happen if: • You're using a very old browser • JavaScript is disabled • The page didn't fully load Try refreshing the page. If the issue persists, try Chrome, Firefox, or Safari." to "Dies kann sein passieren, wenn: • Sie einen sehr alten Browser verwenden • JavaScript deaktiviert ist • Die Seite nicht vollständig geladen wurde Versuchen Sie, die Seite zu aktualisieren. Wenn das Problem weiterhin besteht, versuchen Sie es mit Chrome, Firefox oder Safari.",
    "This was actually {label}." to "Das war tatsächlich {label}.",
    "This was {label}." to "Das war {label}.",
    "Threat Alerts" to "Bedrohungswarnungen",
    "Threat Analysis" to "Bedrohungsanalyse",
    "Threat Analysis Report" to "Bedrohungsanalysebericht",
    "Threat Confidence" to "Bedrohungsvertrauen",
    "Threat Database" to "Bedrohung Datenbank",
    "Threat Detected" to "Bedrohung erkannt",
    "Threat Verdict" to "Bedrohungsurteil",
    "Threat alerts" to "Bedrohungswarnungen",
    "Threat blocked and reported" to "Bedrohung blockiert und gemeldet",
    "Threat database is up to date" to "Bedrohungsdatenbank ist auf dem neuesten Stand",
    "Threat signatures updated to v2.4.1" to "Bedrohungssignaturen aktualisiert auf v2.4.1",
    "Threats" to "Bedrohungen",
    "Time" to "Zeit",
    "Tips for better scanning: • Ensure good lighting • Hold the camera steady • Fill the frame with the QR code • Avoid glare or reflections • Try uploading a clearer image" to "Tipps für besseres Scannen: • Sorgen Sie für gute Beleuchtung • Halten Sie die Kamera ruhig • Füllen Sie den Rahmen mit dem QR-Code • Vermeiden Sie Blendung oder Reflexionen • Versuchen Sie, ein klareres Bild hochzuladen",
    "Today, 04:00 AM" to "Heute, 04:00 Uhr",
    "Today, 14:32:05" to "Heute, 14:32:05",
    "Today, {time}" to "Heute, {time}",
    "Toggle Judge Mode" to "Beurteilungsmodus umschalten",
    "Toggle Language" to "Sprache umschalten",
    "Toggle Theme" to "Thema umschalten",
    "Toggle light/dark mode" to "Hell-/Dunkelmodus umschalten",
    "Toggle menu" to "Menü umschalten",
    "Toggle theme" to "Thema umschalten",
    "Top 100 Alexa Rank - whitelisted" to "Oben 100 Alexa Rank – auf der Whitelist",
    "Top 1k Alexa Rank whitelisted offline." to "Top 1k Alexa Rank offline auf der Whitelist.",
    "Top Analysis Factors" to "Top-Analysefaktoren",
    "Torch" to "Taschenlampe",
    "Torch error" to "Taschenlampenfehler",
    "Torch not available" to "Taschenlampe nicht verfügbar",
    "Torch off" to "Taschenlampe aus",
    "Torch on" to "Taschenlampe am",
    "Training" to "Schulung",
    "Training Centre" to "Schulungszentrum",
    "Trust Centre" to "Vertrauensstellungszentrum",
    "Try Again" to "Erneut versuchen",
    "Try It Now!" to "Jetzt ausprobieren!",
    "Typosquatting" to "Typosquatting",
    "Typosquatting Detected" to "Typosquatting erkannt",
    "Typosquatting pattern detected" to "Typosquatting-Muster erkannt",
    "UNKNOWN" to "UNBEKANNT",
    "URL" to "URL",
    "URL Shortener" to "URL-Shortener",
    "URL Shortener Detected" to "URL-Shortener erkannt",
    "URL contains Cyrillic, Greek, or other lookalike Unicode characters" to "URL enthält kyrillische, griechische oder andere ähnliche Unicode-Zeichen",
    "URL contains another URL in query parameters" to "URL enthält eine andere URL in Abfrageparametern",
    "URL copied to clipboard!" to "URL wurde kopiert Zwischenablage!",
    "URL exceeds 100 characters" to "URL überschreitet 100 Zeichen",
    "URL parsing (please update your browser)" to "URL-Analyse (bitte aktualisieren Sie Ihren Browser)",
    "URL pasted - press Enter to analyze" to "URL eingefügt – drücken Sie die Eingabetaste, um sie zu analysieren",
    "URL path contains /login, /signin, /verify, /secure, /account" to "URL-Pfad enthält /login, /signin, /verify, /secure, /account",
    "URL to analyze" to "URL zur Analyse",
    "URL uses raw IP address instead of domain name" to "URL verwendet rohe IP-Adresse anstelle der Domäne Name",
    "URL:" to "URL:",
    "URL: {url}" to "URL: {url}",
    "URL: {url}\\nVerdict: {verdict}\\nConfidence: {confidence}%" to "URL: {url}\\nUrteil: {verdict}\\nKonfidenz: {confidence}%",
    "URLs are risky!" to "URLs sind riskant!",
    "Unable to determine verdict. Please try again." to "Urteil kann nicht ermittelt werden. Bitte versuchen Sie es erneut.",
    "Unknown" to "Unbekannt",
    "Unknown URL" to "Unbekannte URL",
    "Unknown Verdict" to "Unbekanntes Urteil",
    "Unknown sender number" to "Unbekannte Absendernummer",
    "Unsolicited prize notification" to "Unaufgeforderte Gewinnbenachrichtigung",
    "Upload" to "Hochladen",
    "Upload Image" to "Bild hochladen",
    "Upload Image Instead" to "Bild hochladen Stattdessen",
    "Urgency tactics in message" to "Dringlichkeitstaktiken in der Nachricht",
    "Use condensed layout for results" to "Komprimiertes Layout für Ergebnisse verwenden",
    "Users may not notice subtle character swaps like \"1\" for \"l\" or \"0\" for \"o\"" to "Benutzer bemerken möglicherweise subtile Zeichenvertauschungen wie „1“ für „l“ oder „0“ für „o“",
    "Uses bit.ly, t.co, tinyurl, or similar shortening service" to "Verwendet bit.ly, t.co, tinyurl oder einen ähnlichen Verkürzungsdienst",
    "Uses high-risk TLDs like .tk, .ml, .ga, .cf, .xyz" to "Verwendet TLDs mit hohem Risiko wie .tk, .ml, .ga, .cf, .xyz",
    "VERIFIED SAFE" to "VERIFIZIERTE SICHERHEIT",
    "VS" to "VS",
    "VS MODE" to "VS-MODUS",
    "Valid Extended Validation certificate" to "Gültiges Extended-Validation-Zertifikat",
    "Valid Google certificate" to "Gültiges Google-Zertifikat",
    "Valid SSL Certificate" to "Gültiges SSL Zertifikat",
    "Verdict" to "Urteil",
    "Verdict: {verdict}" to "Urteil: {verdict}",
    "VerdictPhish" to "VerdictPhish",
    "VerdictSafe" to "VerdictSafe",
    "VerdictWarn" to "VerdictWarn",
    "Verified by Mehr Guard Enterprise" to "Verifiziert durch Mehr Guard Enterprise",
    "Verified by Mehr Guard Enterprise v{version}" to "Verifiziert durch Mehr Guard Enterprise v{version}",
    "Verified by local heuristics v2.4. No phishing patterns, obfuscated scripts, or blacklist matches found." to "Verifiziert durch lokale Heuristik v2.4. Keine Phishing-Muster, verschleierten Skripte oder Blacklist-Übereinstimmungen gefunden.",
    "Verifying..." to "Überprüft...",
    "Version" to "Version",
    "Very High" to "Sehr hoch",
    "View All" to "Alle anzeigen",
    "View Full History" to "Vollständigen Verlauf anzeigen",
    "View Full Report" to "Vollständigen Bericht anzeigen",
    "View John Smith\\'s professional profile on LinkedIn." to "Sehen Sie sich das berufliche Profil von John Smith auf LinkedIn an.",
    "View Security Audit" to "Sicherheitsaudit anzeigen",
    "View detailed analysis in dashboard" to "Detaillierte Analyse im Dashboard anzeigen",
    "Visual Appearance (What user sees)" to "Visuelles Erscheinungsbild (Was der Benutzer sieht)",
    "WARN" to "WARNEN",
    "Warning" to "Warnung",
    "We detect multiple attack types:" to "Wir erkennen mehrere Angriffstypen:",
    "We strictly disable outgoing telemetry for scans. Scan results and image hashes remain local." to "Wir deaktivieren die ausgehende Telemetrie für Scans strikt. Scanergebnisse und Bild-Hashes bleiben lokal.",
    "Welcome to Jira - project tracking for agile teams." to "Willkommen bei Jira – Projektverfolgung für agile Teams.",
    "Welcome to Mehr Guard" to "Willkommen bei Mehr Guard",
    "What it checks:" to "Was es prüft:",
    "Why it matters:" to "Warum es wichtig ist:",
    "Why the bot flagged it" to "Warum der Bot es markiert hat",
    "Why this verdict?" to "Warum dieses Urteil?",
    "Without other risk signals, login paths on safe domains would not increase score significantly." to "Ohne andere Risikosignale würden Anmeldepfade auf sicheren Domänen die Punktzahl nicht wesentlich erhöhen.",
    "Works 100% offline!" to "Funktioniert 100 % offline!",
    "Workspace / Security / Reports" to "Arbeitsbereich / Sicherheit / Berichte",
    "Would you like to report this URL?\\n\\nOptions:\\n1. PhishTank - Click OK to open submission page\\n2. Email - Click Cancel to compose email\\n\\nURL: {url}" to "Möchten Sie diese URL melden?\\n\\nOptionen:\\n1. PhishTank – Klicken Sie auf „OK“, um die Einreichungsseite zu öffnen\\n2. E-Mail – Klicken Sie auf „Abbrechen“, um eine E-Mail zu verfassen.\\n\\nURL: {url}",
    "Wrong Verdict?" to "Falsches Urteil?",
    "Wrong!" to "Falsch!",
    "Yesterday" to "Gestern",
    "You" to "Du",
    "You can still use Mehr Guard by uploading images or pasting URLs directly." to "Sie können Mehr Guard weiterhin verwenden, indem Sie Bilder hochladen oder URLs direkt einfügen.",
    "You can still use Mehr Guard: • Upload QR code images • Paste URLs directly • Use the sample URLs provided" to "Sie können Mehr Guard weiterhin verwenden: • QR-Code-Bilder hochladen • URLs direkt einfügen • Die bereitgestellten Beispiel-URLs verwenden",
    "You correctly identified this as {label}." to "Sie haben dies korrekt als {label} identifiziert.",
    "You have 3 unread emails in your inbox." to "Sie haben 3 ungelesene E-Mails in Ihrem Posteingang.",
    "You identified the safe URL correctly." to "Sie haben die sichere URL korrekt identifiziert.",
    "You spotted it correctly as {label}!" to "Du hast es richtig als {label} erkannt!",
    "You spotted the phishing URL correctly." to "Sie haben die Phishing-URL richtig erkannt.",
    "You're offline — analysis still works!" to "Sie sind offline – die Analyse funktioniert immer noch!",
    "You're reporting that this verdict may be wrong:" to "Sie berichten, dass dieses Urteil möglicherweise falsch ist:",
    "You\\'re Offline" to "Du bist offline",
    "Your Score" to "Ihr Punktestand",
    "Your browser doesn\\'t support camera access, or you\\'re on a device without a camera." to "Ihr Browser unterstützt keinen Kamerazugriff oder Sie verwenden ein Gerät ohne Kamera.",
    "Your data never leaves this device. All processing is local. No tracking, no uploads." to "Ihre Daten verlassen niemals dieses Gerät. Die gesamte Verarbeitung erfolgt lokal. Kein Tracking, keine Uploads.",
    "Your data stays on-device." to "Ihre Daten bleiben auf dem Gerät.",
    "\\nRisk Score:" to "\\nRisikobewertung:",
    "a phishing attempt" to "ein Phishing-Versuch",
    "actually legitimate" to "eigentlich legitim",
    "bit.ly shortener" to "bit.ly-Shortener",
    "characters often associated with phishing campaigns targeting financial institutions. The domain age is" to "Zeichen, die häufig mit Phishing-Kampagnen gegen Finanzinstitute in Verbindung gebracht werden. Das Domainalter beträgt",
    "critical" to "kritisch",
    "danger" to "Gefahr",
    "for core services." to "für Kerndienstleistungen.",
    "high" to "hoch",
    "homoglyph obfuscation" to "Homoglyphen-Verschleierung",
    "in your browser." to "in Ihrem Browser.",
    "just now" to "soeben",
    "low" to "niedrig",
    "malicious" to "bösartig",
    "medium" to "Medium",
    "offline" to "offline",
    "online" to "online",
    "or click \"Upload\" to select a file" to "oder klicken Sie auf „Hochladen“, um eine Datei auszuwählen",
    "phishing" to "Phishing",
    "risk-badge danger" to "Risiko-Abzeichen-Gefahr",
    "risk-badge warning" to "Warnung vor Risikoplakette",
    "risk-item-expanded severity-" to "Risikoelement-erweiterter Schweregrad-",
    "safe" to "sicher",
    "suspicious" to "verdächtig",
    "to analyze," to "zu analysieren,",
    "to focus," to "sich konzentrieren,",
    "to reset" to "zurücksetzen",
    "unknown" to "unbekannt",
    "v2.4.1 •" to "v2.4.1 •",
    "warning" to "Warnung",
    "without compromising data privacy." to "ohne den Datenschutz zu gefährden.",
    "zero-latency phishing detection" to "Latenzfreie Phishing-Erkennung",
    "{date}, {time}" to "{date}, {time}",
    "{days} day ago" to "Vor {days} Tag",
    "{days} days ago" to "{days} Tage her",
    "{hours} hour ago" to "Vor {hours} Stunde",
    "{hours} hours ago" to "Vor {hours} Stunden",
    "{label} disabled" to "{label} deaktiviert",
    "{label} enabled" to "{label} aktiviert",
    "{level} Confidence" to "{level} Vertrauen",
    "{minutes} minute ago" to "Vor {minutes} Minute",
    "{minutes} minutes ago" to "Vor {minutes} Minuten",
    "{months} month ago" to "{months} vor einem Monat",
    "{months} months ago" to "{months} vor Monaten",
    "{points} pts" to "{points} Pkt",
    "{title}: {summary}" to "{title}: {summary}",
    "{weeks} week ago" to "{weeks} Woche",
    "{weeks} weeks ago" to "{weeks} vor Wochen",
    "© 2024 Mehr Guard Security Inc. All rights reserved." to "© 2024 Mehr Guard Security Inc. Alle Rechte vorbehalten.",
    "हिन्दी" to "Ja",
    "⌨️ Tip: Press" to "⌨️ Tipp: Drücken",
    "⚠ Try Phishing URL" to "⚠ Versuchen Sie es mit einer Phishing-URL",
    "✅ No data leaves your device" to "✅ Keine Daten verlassen Ihr Gerät",
    "✅ Same engine as mobile apps" to "✅ Gleiche Engine wie mobile Apps",
    "✅ Works without internet" to "✅ Funktioniert ohne Internet",
    "✓ No brand impersonation" to "✓ Keine Markenfälschung",
    "✓ No homograph attacks" to "✓ Keine homographischen Angriffe",
    "✓ No suspicious patterns" to "✓ Keine verdächtigen Muster",
    "✓ Safe TLD" to "✓ Sichere TLD",
    "✓ Try Safe URL" to "✓ Versuchen Sie es mit Safe URL",
    "日本語" to "日本語",
    "简体中文" to "简体中文",
    "🌐 Homograph attacks (Cyrillic chars)" to "🌐 Homograph-Angriffe (kyrillische Zeichen)",
    "🎉 You Win!" to "🎉 Du gewinnst!",
    "🎬 Demo Mode: Click \"Analyze URL\" to see detection" to "🎬 Demo-Modus: Klicken Sie auf „URL analysieren“, um die Erkennung anzuzeigen",
    "🎮 Craft a sneaky phishing URL..." to "🎮 Erstellen Sie eine hinterhältige Phishing-URL ...",
    "🎮 Game Mode: Try to craft a URL that gets detected as SAFE!" to "🎮 Spielemodus: Versuchen Sie, eine URL zu erstellen, die als SICHER erkannt wird!",
    "🏆 Players challenged:" to "🏆 Herausgeforderte Spieler:",
    "🏆 You beat the bot! Score: {score}/{attempts}" to "🏆 Du hast den Bot besiegt! Ergebnis: {score}/{attempts}",
    "💡 What would reduce this?" to "💡Was würde dies reduzieren?",
    "🔒 100% offline • Zero data collection • Open source (Apache 2.0)" to "🔒 100 % offline • Keine Datenerfassung • Open Source (Apache 2.0)",
    "🔒 Zero data collection • 🚀 Same engine as Android & iOS • 🧠 Ensemble ML (25+ heuristics)" to "🔒 Keine Datenerfassung • 🚀 Gleiche Engine wie Android und iOS • 🧠 Ensemble ML (25+ Heuristiken)",
    "🔗 URL shortener obfuscation" to "🔗 URL-Shortener-Verschleierung",
    "🔤 Typosquatting (paypa1 → paypal)" to "🔤 Typosquatting (paypa1 → paypal)",
    "🛡️ Mehr Guard Analysis" to "🛡️ Mehr Guard Analyse",
    "🛡️ Mehr Guard — Kotlin Multiplatform QRishing Detector" to "🛡️ [[MARKE]] – Kotlin Multiplattform-QRishing-Detektor",
    "🤖 Bot wins! Phishing detected. Score: {score}/{attempts}" to "🤖 Bot gewinnt! Phishing erkannt. Ergebnis: {score}/{attempts}",
    "🧑‍⚖️ Demo: Forced MALICIOUS result" to "🧑‍⚖️ Demo: Erzwungenes SCHÄDLICHES Ergebnis",
    "🧑‍⚖️ Judge Mode ON - All URLs will show MALICIOUS" to "🧑‍⚖️ Beurteilungsmodus EIN – Alle URLs zeigen BÖSLICH an",
    "🧑‍⚖️ Judge Mode activated - Demo history loaded!" to "🧑‍⚖️ Beurteilungsmodus aktiviert – Demo-Verlauf geladen!",
    "🧪 Try these examples:" to "🧪 Probieren Sie diese Beispiele aus:",
    "Added {date}" to "{date} hinzugefügt",
    "Analyzing..." to "Analysieren...",
    "Camera N/A" to "Kamera nicht verfügbar",
    "Error analyzing URL: {error}" to "Fehler beim Analysieren der URL: {error}",
    "Challenge Mehr Guard's offline AI engine. Can you spot phishing URLs faster than the bot?" to "Fordern Sie die Offline-KI-Engine von Mehr Guard heraus. Können Sie Phishing-URLs schneller erkennen als der Bot?",
    "Paste URL to analyze (e.g., https://example.com)" to "URL zum Analysieren einfügen (z. B. https://example.com)",
    "Mehr Guard Active Scanner - Real-time QR code scanning with AI-powered phishing detection." to "Mehr Guard Aktiver Scanner – QR-Code-Scanning in Echtzeit mit KI-gestützter Phishing-Erkennung.",
    "Mehr Guard Dashboard - Enterprise offline QR code security with explainable threat detection." to "Mehr Guard Dashboard – Enterprise-Offline-QR-Code-Sicherheit mit erklärbarer Bedrohungserkennung.",
    "Mehr Guard Privacy Settings - 100% offline protection with zero cloud telemetry." to "Mehr Guard Datenschutzeinstellungen – 100 % Offline-Schutz ohne Cloud-Telemetrie.",
    "Mehr Guard Report Export - Generate and download threat analysis reports in PDF or JSON format." to "Mehr Guard Berichtsexport – Bedrohungsanalyseberichte als PDF oder JSON erstellen und herunterladen.",
    "Mehr Guard Threat Analysis - Detailed scan result showing attack breakdown and security recommendations." to "Mehr Guard Bedrohungsanalyse – Detailliertes Scan-Ergebnis mit Angriffsauswertung und Sicherheitsempfehlungen.",
    "Mehr Guard Trust Centre - Manage privacy controls, detection sensitivity, and security lists." to "Mehr Guard Trust Centre – Datenschutzkontrollen, Erkennungsempfindlichkeit und Sicherheitslisten verwalten.",
    "Mehr Guard Web - AI-powered phishing detection running entirely in your browser. Scan and analyze URLs for security threats." to "Mehr Guard Web – KI-gestützte Phishing-Erkennung läuft vollständig in Ihrem Browser. Scannen und analysieren Sie URLs auf Sicherheitsbedrohungen.",
    "Mehr Guard scan results - AI-powered phishing detection with detailed security analysis." to "Mehr Guard Scan-Ergebnisse – KI-gestützte Phishing-Erkennung mit detaillierter Sicherheitsanalyse.",
    "why" to "warum",
    "heuristics" to "heuristiken",
    "redirects" to "weiterleitungen",
    "ssl_issuer" to "ssl_aussteller",
    "subdomain_chaining" to "subdomain_verkettung",
    "suspicious_tld" to "verdächtige_tld",
    "threat_type" to "bedrohungstyp",
    
    // Result Screen Verdicts
    WebStringKey.VerdictSuspicious to "VERDÄCHTIGE AKTIVITÄT",
    WebStringKey.VerdictWarning to "Warnung",
    WebStringKey.VerdictSuspiciousDesc to "Der gescannte QR-Code zeigt verdächtige Muster, die auf potenzielle Sicherheitsrisiken hindeuten. Fahren Sie mit Vorsicht fort.",
    WebStringKey.VerdictMinorConcerns to "KLEINERE BEDENKEN",
    WebStringKey.VerdictCaution to "Vorsicht",
    WebStringKey.VerdictMinorConcernsDesc to "Einige kleinere Sicherheitsbedenken wurden identifiziert. Der Link scheint größtenteils sicher, aber eine Überprüfung wird empfohlen.",
    WebStringKey.VerdictVerifiedSafe to "VERIFIZIERT SICHER",
    WebStringKey.VerdictSafeLabel to "Sicher",
    WebStringKey.VerdictVerifiedSafeDesc to "Keine Sicherheitsbedrohungen erkannt. Der QR-Code führt zu einem verifizierten sicheren Ziel.",
    WebStringKey.VerdictNoActivity to "Keine Aktivität",
    WebStringKey.VerdictAwaitingScan to "Warte auf Scan",
    WebStringKey.VerdictNoActivityDesc to "Keine Scandaten verfügbar. Bitte scannen Sie einen QR-Code oder geben Sie eine URL zur Analyse ein.",
    WebStringKey.ScanQrToSeeActivity to "Scannen Sie einen QR-Code, um Ihre Aktivität hier zu sehen",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "Datenpunkt",
    WebStringKey.ProcessingEnv to "Verarbeitungsumgebung",
    WebStringKey.ExternalTransmission to "Externe Übertragung",
    WebStringKey.RawImageBuffer to "Rohbildpuffer",
    WebStringKey.LocalMemoryRam to "Lokaler Speicher (RAM)",
    WebStringKey.TransmissionNone to "Keine",
    WebStringKey.DecodedUrlPayload to "Dekodierte URL/Nutzlast",
    WebStringKey.LocalAnalysis to "Lokale Analyse",
    WebStringKey.ThreatVerdictLabel to "Bedrohungsurteil",
    WebStringKey.LocalDatabase to "Lokale Datenbank",
    
    // Reason Code Titles and Descriptions
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "JavaScript-URL",
    WebStringKey.ReasonJavascriptUrlDesc to "JavaScript-URL-Schema erkannt - führt Code beim Klicken aus",
    WebStringKey.ReasonDataUriTitle to "Daten-URI",
    WebStringKey.ReasonDataUriDesc to "Daten-URI-Schema erkannt - kann eingebetteten bösartigen Code enthalten",
    WebStringKey.ReasonAtSymbolInjectionTitle to "@-Symbol-Injektion",
    WebStringKey.ReasonAtSymbolInjectionDesc to "URL enthält @-Symbol, das auf einen möglichen Anmeldedatendiebstahlversuch hinweist",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "Homograph-Angriff",
    WebStringKey.ReasonHomographDesc to "Internationalisierter Domainname (IDN) könnte eine andere Domain imitieren",
    WebStringKey.ReasonMixedScriptTitle to "Gemischte Schrift",
    WebStringKey.ReasonMixedScriptDesc to "Hostname enthält Zeichen aus verschiedenen Schriftsystemen (möglicher Spoofing-Versuch)",
    WebStringKey.ReasonLookalikeCharsTitle to "Ähnlich aussehende Zeichen",
    WebStringKey.ReasonLookalikeCharsDesc to "Domain enthält Unicode-Zeichen, die ASCII-Buchstaben ähneln",
    WebStringKey.ReasonZeroWidthCharsTitle to "Zeichen mit Nullbreite",
    WebStringKey.ReasonZeroWidthCharsDesc to "Versteckte Unicode-Zeichen mit Nullbreite erkannt (Verschleierungsversuch)",
    WebStringKey.ReasonIpHostTitle to "IP-Host",
    WebStringKey.ReasonIpHostDesc to "URL verwendet IP-Adresse anstelle eines Domainnamens",
    WebStringKey.ReasonCredentialParamTitle to "Anmeldedaten-Parameter",
    WebStringKey.ReasonCredentialParamDesc to "URL enthält anmeldedatenbezogene Parameter (Passwort, Token usw.)",
    WebStringKey.ReasonBrandImpersonationTitle to "Markenimitation",
    WebStringKey.ReasonBrandImpersonationDesc to "URL scheint eine bekannte Marke zu imitieren",
    WebStringKey.ReasonBrandInSubdomainTitle to "Marke in Subdomain",
    WebStringKey.ReasonBrandInSubdomainDesc to "Markenname erscheint in Subdomain, aber nicht in der Hauptdomain",
    WebStringKey.ReasonRiskyExtensionTitle to "Riskante Erweiterung",
    WebStringKey.ReasonRiskyExtensionDesc to "Pfad enthält potenziell gefährliche Dateierweiterung",
    WebStringKey.ReasonDoubleExtensionTitle to "Doppelte Erweiterung",
    WebStringKey.ReasonDoubleExtensionDesc to "Doppelte Dateierweiterung erkannt (häufige Malware-Taktik)",
    WebStringKey.ReasonEncodedPayloadTitle to "Codierte Nutzlast",
    WebStringKey.ReasonEncodedPayloadDesc to "Große codierte Daten in URL-Parametern erkannt",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTP statt HTTPS",
    WebStringKey.ReasonHttpNotHttpsDesc to "URL verwendet unsicheres HTTP-Protokoll anstelle von HTTPS",
    WebStringKey.ReasonSuspiciousTldTitle to "Verdächtige TLD",
    WebStringKey.ReasonSuspiciousTldDesc to "Top-Level-Domain wird häufig für Phishing verwendet",
    WebStringKey.ReasonHighEntropyHostTitle to "Host mit hoher Entropie",
    WebStringKey.ReasonHighEntropyHostDesc to "Domainname scheint zufällig generiert zu sein",
    WebStringKey.ReasonRedirectParamTitle to "Weiterleitungsparameter",
    WebStringKey.ReasonRedirectParamDesc to "URL enthält Weiterleitungsparameter, der zu einer anderen Seite führen kann",
    WebStringKey.ReasonDeepSubdomainTitle to "Tiefe Subdomain",
    WebStringKey.ReasonDeepSubdomainDesc to "Übermäßige Subdomain-Tiefe (kann echte Domain verbergen)",
    WebStringKey.ReasonMultiTldTitle to "Mehrere TLDs",
    WebStringKey.ReasonMultiTldDesc to "Mehrere TLD-ähnliche Segmente im Domainnamen",
    WebStringKey.ReasonNumericSubdomainTitle to "Numerische Subdomain",
    WebStringKey.ReasonNumericSubdomainDesc to "Rein numerische Subdomain erkannt",
    WebStringKey.ReasonNonStandardPortTitle to "Nicht-Standard-Port",
    WebStringKey.ReasonNonStandardPortDesc to "URL verwendet nicht-standardmäßige Portnummer",
    WebStringKey.ReasonSuspiciousPortTitle to "Verdächtiger Port",
    WebStringKey.ReasonSuspiciousPortDesc to "URL verwendet Port, der häufig mit Angriffen assoziiert wird",
    WebStringKey.ReasonFragmentHidingTitle to "Fragment-Versteckung",
    WebStringKey.ReasonFragmentHidingDesc to "URL-Fragment scheint zusätzlichen Inhalt zu verbergen",
    WebStringKey.ReasonExcessiveEncodingTitle to "Übermäßige Codierung",
    WebStringKey.ReasonExcessiveEncodingDesc to "Übermäßige URL-Codierung erkannt (Verschleierungsversuch)",
    WebStringKey.ReasonDomainAgePatternTitle to "Domain-Alter-Muster",
    WebStringKey.ReasonDomainAgePatternDesc to "Domainname entspricht Mustern automatisch generierter Domains",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "URL-Verkürzer",
    WebStringKey.ReasonUrlShortenerDesc to "URL verwendet Verkürzungsdienst (verbirgt echtes Ziel)",
    WebStringKey.ReasonSuspiciousPathTitle to "Verdächtiger Pfad",
    WebStringKey.ReasonSuspiciousPathDesc to "Pfad enthält verdächtige Schlüsselwörter (Anmeldung, Verifizierung usw.)",
    WebStringKey.ReasonLongUrlTitle to "Lange URL",
    WebStringKey.ReasonLongUrlDesc to "Ungewöhnlich lange URL",
    WebStringKey.ReasonCredentialKeywordsTitle to "Anmeldedaten-Schlüsselwörter",
    WebStringKey.ReasonCredentialKeywordsDesc to "URL enthält Schlüsselwörter zum Sammeln von Anmeldedaten",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "Nicht analysierbare URL",
    WebStringKey.ReasonUnparseableDesc to "URL konnte nicht vollständig analysiert werden",
    WebStringKey.ReasonAnalysisCompleteTitle to "Analyse abgeschlossen",
    WebStringKey.ReasonAnalysisCompleteDesc to "Analyse erfolgreich abgeschlossen",
    
    // ML Score Labels
    WebStringKey.MlPhishingScore to "ML-Phishing-Score",
    WebStringKey.MlCharacterAnalysis to "Zeichenanalyse",
    WebStringKey.MlFeatureAnalysis to "Feature-Analyse",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "IDN / Punycode-Domain",
    WebStringKey.IdnPunycodeDomainDesc to "Diese Domain verwendet internationalisierte Zeichen. Sichere Anzeige:",
    WebStringKey.MixedScriptAttackTitle to "Mixed-Script-Angriff",
    WebStringKey.MixedScriptAttackDesc to "Domain enthält Zeichen aus mehreren Schriftsystemen (z.B. Kyrillisch + Latein). Häufig bei Homograph-Angriffen.",
    WebStringKey.ConfusableCharsTitle to "Verwechselbare Zeichen",
    WebStringKey.ConfusableCharsDesc to "Domain enthält Zeichen, die häufigen Buchstaben ähneln (z.B. 'а' vs 'a')."
)
